import { Union, Record } from "../fable-library-js.4.24.0/Types.js";
import { float64_type, tuple_type, list_type, obj_type, option_type, lambda_type, unit_type, class_type, int32_type, array_type, bool_type, union_type, record_type, string_type } from "../fable-library-js.4.24.0/Reflection.js";
import { join } from "../fable-library-js.4.24.0/String.js";
import { ofSeq, ofArray } from "../fable-library-js.4.24.0/List.js";

export class DataTabster extends Record {
    constructor(data$002Dtabster) {
        super();
        this["data-tabster"] = data$002Dtabster;
    }
}

export function DataTabster_$reflection() {
    return record_type("FS.FluentUI.DataTabster", [], DataTabster, () => [["data-tabster", string_type]]);
}

export class InputDefaultAppearance extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["outline", "filled-darker", "filled-lighter"];
    }
}

export function InputDefaultAppearance_$reflection() {
    return union_type("FS.FluentUI.InputDefaultAppearance", [], InputDefaultAppearance, () => [[], [], []]);
}

export class OverridesContextValue_unstable extends Record {
    constructor(inputDefaultAppearance) {
        super();
        this.inputDefaultAppearance = inputDefaultAppearance;
    }
}

export function OverridesContextValue_unstable_$reflection() {
    return record_type("FS.FluentUI.OverridesContextValue_unstable", [], OverridesContextValue_unstable, () => [["inputDefaultAppearance", InputDefaultAppearance_$reflection()]]);
}

export class TagGroupDismissData extends Record {
    constructor(dismissedTagValue) {
        super();
        this.dismissedTagValue = dismissedTagValue;
    }
}

export function TagGroupDismissData_$reflection() {
    return record_type("FS.FluentUI.TagGroupDismissData", [], TagGroupDismissData, () => [["dismissedTagValue", string_type]]);
}

export class FieldControlProps extends Record {
    constructor(id, aria$002Dlabelledby, aria$002Ddescribedby, aria$002Dinvalid, aria$002Drequired) {
        super();
        this.id = id;
        this["aria-labelledby"] = aria$002Dlabelledby;
        this["aria-describedby"] = aria$002Ddescribedby;
        this["aria-invalid"] = aria$002Dinvalid;
        this["aria-required"] = aria$002Drequired;
    }
}

export function FieldControlProps_$reflection() {
    return record_type("FS.FluentUI.FieldControlProps", [], FieldControlProps, () => [["id", string_type], ["aria-labelledby", string_type], ["aria-describedby", string_type], ["aria-invalid", bool_type], ["aria-required", bool_type]]);
}

export class PartitionBreadcrumbItemsOptions$1 extends Record {
    constructor(items, maxDisplayedItems, overflowIndex) {
        super();
        this.items = items;
        this.maxDisplayedItems = (maxDisplayedItems | 0);
        this.overflowIndex = (overflowIndex | 0);
    }
}

export function PartitionBreadcrumbItemsOptions$1_$reflection(gen0) {
    return record_type("FS.FluentUI.PartitionBreadcrumbItemsOptions`1", [gen0], PartitionBreadcrumbItemsOptions$1, () => [["items", array_type(gen0)], ["maxDisplayedItems", int32_type], ["overflowIndex", int32_type]]);
}

export class PartitionBreadcrumbItems$1 extends Record {
    constructor(endDisplayedItems, overflowItems, startDisplayedItems) {
        super();
        this.endDisplayedItems = endDisplayedItems;
        this.overflowItems = overflowItems;
        this.startDisplayedItems = startDisplayedItems;
    }
}

export function PartitionBreadcrumbItems$1_$reflection(gen0) {
    return record_type("FS.FluentUI.PartitionBreadcrumbItems`1", [gen0], PartitionBreadcrumbItems$1, () => [["endDisplayedItems", array_type(gen0)], ["overflowItems", array_type(gen0)], ["startDisplayedItems", array_type(gen0)]]);
}

export function FieldControlPropsModule_toReactProperties(props) {
    return ofArray([["id", props.id], ["aria-labelledby", join(" ", [props["aria-labelledby"]])], ["aria-describedby", join(" ", [props["aria-describedby"]])], ["aria-invalid", props["aria-invalid"]], ["aria-required", props["aria-required"]]]);
}

export class IgnoreKeyDown extends Record {
    constructor(Tab, Escape, Enter, ArrowUp, ArrowDown, ArrowLeft, ArrowRight, PageUp, PageDown, Home, End) {
        super();
        this.Tab = Tab;
        this.Escape = Escape;
        this.Enter = Enter;
        this.ArrowUp = ArrowUp;
        this.ArrowDown = ArrowDown;
        this.ArrowLeft = ArrowLeft;
        this.ArrowRight = ArrowRight;
        this.PageUp = PageUp;
        this.PageDown = PageDown;
        this.Home = Home;
        this.End = End;
    }
}

export function IgnoreKeyDown_$reflection() {
    return record_type("FS.FluentUI.IgnoreKeyDown", [], IgnoreKeyDown, () => [["Tab", bool_type], ["Escape", bool_type], ["Enter", bool_type], ["ArrowUp", bool_type], ["ArrowDown", bool_type], ["ArrowLeft", bool_type], ["ArrowRight", bool_type], ["PageUp", bool_type], ["PageDown", bool_type], ["Home", bool_type], ["End", bool_type]]);
}

export class ModalAttributes extends Record {
    constructor(modalAttributes, triggerAttributes) {
        super();
        this.modalAttributes = modalAttributes;
        this.triggerAttributes = triggerAttributes;
    }
}

export function ModalAttributes_$reflection() {
    return record_type("FS.FluentUI.ModalAttributes", [], ModalAttributes, () => [["modalAttributes", class_type("Feliz.IReactProperty")], ["triggerAttributes", class_type("Feliz.IReactProperty")]]);
}

export class ModalTabsters extends Record {
    constructor(modalAttributes, triggerAttributes) {
        super();
        this.modalAttributes = modalAttributes;
        this.triggerAttributes = triggerAttributes;
    }
}

export function ModalTabsters_$reflection() {
    return record_type("FS.FluentUI.ModalTabsters", [], ModalTabsters, () => [["modalAttributes", DataTabster_$reflection()], ["triggerAttributes", DataTabster_$reflection()]]);
}

export class SyntheticEvent extends Record {
    constructor(nativeEvent, currentTarget, target, bubbles, cancelable, defaultPrevented, eventPhase, isTrusted, preventDefault, isDefaultPrevented, stopPropagation, isPropagationStopped, persist, timeStamp, type) {
        super();
        this.nativeEvent = nativeEvent;
        this.currentTarget = currentTarget;
        this.target = target;
        this.bubbles = bubbles;
        this.cancelable = cancelable;
        this.defaultPrevented = defaultPrevented;
        this.eventPhase = (eventPhase | 0);
        this.isTrusted = isTrusted;
        this.preventDefault = preventDefault;
        this.isDefaultPrevented = isDefaultPrevented;
        this.stopPropagation = stopPropagation;
        this.isPropagationStopped = isPropagationStopped;
        this.persist = persist;
        this.timeStamp = (timeStamp | 0);
        this.type = type;
    }
}

export function SyntheticEvent_$reflection() {
    return record_type("FS.FluentUI.SyntheticEvent", [], SyntheticEvent, () => [["nativeEvent", class_type("Browser.Types.MouseEvent")], ["currentTarget", class_type("Browser.Types.HTMLElement")], ["target", class_type("Browser.Types.HTMLElement")], ["bubbles", bool_type], ["cancelable", bool_type], ["defaultPrevented", bool_type], ["eventPhase", int32_type], ["isTrusted", bool_type], ["preventDefault", lambda_type(unit_type, unit_type)], ["isDefaultPrevented", lambda_type(unit_type, bool_type)], ["stopPropagation", lambda_type(unit_type, unit_type)], ["isPropagationStopped", lambda_type(unit_type, bool_type)], ["persist", lambda_type(unit_type, unit_type)], ["timeStamp", int32_type], ["type", string_type]]);
}

export class RefObject$1 extends Record {
    constructor(current) {
        super();
        this.current = current;
    }
}

export function RefObject$1_$reflection(gen0) {
    return record_type("FS.FluentUI.RefObject`1", [gen0], RefObject$1, () => [["current", option_type(gen0)]]);
}

export class ValueProp$1 extends Record {
    constructor(value) {
        super();
        this.value = value;
    }
}

export function ValueProp$1_$reflection(gen0) {
    return record_type("FS.FluentUI.ValueProp`1", [gen0], ValueProp$1, () => [["value", gen0]]);
}

export class OpenProp extends Record {
    constructor(open) {
        super();
        this.open = open;
    }
}

export function OpenProp_$reflection() {
    return record_type("FS.FluentUI.OpenProp", [], OpenProp, () => [["open", bool_type]]);
}

export class SelectedProp extends Record {
    constructor(selected) {
        super();
        this.selected = selected;
    }
}

export function SelectedProp_$reflection() {
    return record_type("FS.FluentUI.SelectedProp", [], SelectedProp, () => [["selected", bool_type]]);
}

export class MenuCheckedValueChangeData extends Record {
    constructor(checkedItems, name) {
        super();
        this.checkedItems = checkedItems;
        this.name = name;
    }
}

export function MenuCheckedValueChangeData_$reflection() {
    return record_type("FS.FluentUI.MenuCheckedValueChangeData", [], MenuCheckedValueChangeData, () => [["checkedItems", array_type(string_type)], ["name", string_type]]);
}

export class MenuOpenChangeData extends Record {
    constructor(bubble, keyboard, open) {
        super();
        this.bubble = bubble;
        this.keyboard = keyboard;
        this.open = open;
    }
}

export function MenuOpenChangeData_$reflection() {
    return record_type("FS.FluentUI.MenuOpenChangeData", [], MenuOpenChangeData, () => [["bubble", option_type(bool_type)], ["keyboard", option_type(bool_type)], ["open", bool_type]]);
}

export class MenuTriggerChildProps extends Record {
    constructor(aria$002Dhaspopup, aria$002Dexpanded, id, ref, onMouseEnter, onMouseLeave, onMouseMove, onContextMenu) {
        super();
        this["aria-haspopup"] = aria$002Dhaspopup;
        this["aria-expanded"] = aria$002Dexpanded;
        this.id = id;
        this.ref = ref;
        this.onMouseEnter = onMouseEnter;
        this.onMouseLeave = onMouseLeave;
        this.onMouseMove = onMouseMove;
        this.onContextMenu = onContextMenu;
    }
}

export function MenuTriggerChildProps_$reflection() {
    return record_type("FS.FluentUI.MenuTriggerChildProps", [], MenuTriggerChildProps, () => [["aria-haspopup", option_type(string_type)], ["aria-expanded", option_type(bool_type)], ["id", string_type], ["ref", class_type("Fable.React.IRefValue`1", [obj_type])], ["onMouseEnter", lambda_type(class_type("Browser.Types.MouseEvent"), unit_type)], ["onMouseLeave", lambda_type(class_type("Browser.Types.MouseEvent"), unit_type)], ["onMouseMove", lambda_type(class_type("Browser.Types.MouseEvent"), unit_type)], ["onContextMenu", lambda_type(class_type("Browser.Types.MouseEvent"), unit_type)]]);
}

export class PopoverTriggerChildProps extends Record {
    constructor(aria$002Dexpanded, ref, onMouseEnter, onMouseLeave, onContextMenu) {
        super();
        this["aria-expanded"] = aria$002Dexpanded;
        this.ref = ref;
        this.onMouseEnter = onMouseEnter;
        this.onMouseLeave = onMouseLeave;
        this.onContextMenu = onContextMenu;
    }
}

export function PopoverTriggerChildProps_$reflection() {
    return record_type("FS.FluentUI.PopoverTriggerChildProps", [], PopoverTriggerChildProps, () => [["aria-expanded", bool_type], ["ref", class_type("Fable.React.IRefValue`1", [obj_type])], ["onMouseEnter", lambda_type(class_type("Browser.Types.MouseEvent"), unit_type)], ["onMouseLeave", lambda_type(class_type("Browser.Types.MouseEvent"), unit_type)], ["onContextMenu", lambda_type(class_type("Browser.Types.MouseEvent"), unit_type)]]);
}

export class OffsetObject extends Record {
    constructor(crossAxis, mainAxis) {
        super();
        this.crossAxis = crossAxis;
        this.mainAxis = (mainAxis | 0);
    }
}

export function OffsetObject_$reflection() {
    return record_type("FS.FluentUI.OffsetObject", [], OffsetObject, () => [["crossAxis", option_type(int32_type)], ["mainAxis", int32_type]]);
}

export class OverflowBoundaryPadding extends Record {
    constructor(top, end, bottom, start) {
        super();
        this.top = (top | 0);
        this.end = (end | 0);
        this.bottom = (bottom | 0);
        this.start = (start | 0);
    }
}

export function OverflowBoundaryPadding_$reflection() {
    return record_type("FS.FluentUI.OverflowBoundaryPadding", [], OverflowBoundaryPadding, () => [["top", int32_type], ["end", int32_type], ["bottom", int32_type], ["start", int32_type]]);
}

export class PositioningImperativeRef extends Record {
    constructor(updatePosition, setTarget) {
        super();
        this.updatePosition = updatePosition;
        this.setTarget = setTarget;
    }
}

export function PositioningImperativeRef_$reflection() {
    return record_type("FS.FluentUI.PositioningImperativeRef", [], PositioningImperativeRef, () => [["updatePosition", lambda_type(unit_type, unit_type)], ["setTarget", lambda_type(option_type(class_type("Browser.Types.HTMLElement")), unit_type)]]);
}

export class OnVisibleChangeData extends Record {
    constructor(visible, documentKeyboardEvent) {
        super();
        this.visible = visible;
        this.documentKeyboardEvent = documentKeyboardEvent;
    }
}

export function OnVisibleChangeData_$reflection() {
    return record_type("FS.FluentUI.OnVisibleChangeData", [], OnVisibleChangeData, () => [["visible", bool_type], ["documentKeyboardEvent", class_type("Browser.Types.KeyboardEvent")]]);
}

export class MountNode extends Record {
    constructor(element, className) {
        super();
        this.element = element;
        this.className = className;
    }
}

export function MountNode_$reflection() {
    return record_type("FS.FluentUI.MountNode", [], MountNode, () => [["element", option_type(class_type("Browser.Types.HTMLElement"))], ["className", string_type]]);
}

export class ChangeEvent extends Record {
    constructor(target) {
        super();
        this.target = target;
    }
}

export function ChangeEvent_$reflection() {
    return record_type("FS.FluentUI.ChangeEvent", [], ChangeEvent, () => [["target", class_type("Browser.Types.EventTarget")]]);
}

export class CheckState extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Checked", "Unchecked", "Mixed"];
    }
}

export function CheckState_$reflection() {
    return union_type("FS.FluentUI.CheckState", [], CheckState, () => [[], [], []]);
}

export function CheckStateModule_fromData(arg) {
    const matchValue = arg.checked;
    if (typeof matchValue === "boolean") {
        if (matchValue) {
            return new CheckState(0, []);
        }
        else {
            return new CheckState(1, []);
        }
    }
    else {
        return new CheckState(2, []);
    }
}

export function Checkbox_toBool(arg) {
    const matchValue = arg.checked;
    if (typeof matchValue === "boolean") {
        return matchValue;
    }
    else {
        return true;
    }
}

export class SwitchOnChangeData extends Record {
    constructor(checked) {
        super();
        this.checked = checked;
    }
}

export function SwitchOnChangeData_$reflection() {
    return record_type("FS.FluentUI.SwitchOnChangeData", [], SwitchOnChangeData, () => [["checked", bool_type]]);
}

export class SpinButtonOnChangeData extends Record {
    constructor(value, displayValue) {
        super();
        this.value = value;
        this.displayValue = displayValue;
    }
}

export function SpinButtonOnChangeData_$reflection() {
    return record_type("FS.FluentUI.SpinButtonOnChangeData", [], SpinButtonOnChangeData, () => [["value", option_type(int32_type)], ["displayValue", string_type]]);
}

export class OptionOnSelectData extends Record {
    constructor(optionValue, optionText, selectedOptions) {
        super();
        this.optionValue = optionValue;
        this.optionText = optionText;
        this.selectedOptions = selectedOptions;
    }
}

export function OptionOnSelectData_$reflection() {
    return record_type("FS.FluentUI.OptionOnSelectData", [], OptionOnSelectData, () => [["optionValue", option_type(string_type)], ["optionText", option_type(string_type)], ["selectedOptions", array_type(string_type)]]);
}

export class ToolbarCheckedValueChangeData extends Record {
    constructor(checkedItems, name) {
        super();
        this.checkedItems = checkedItems;
        this.name = name;
    }
}

export function ToolbarCheckedValueChangeData_$reflection() {
    return record_type("FS.FluentUI.ToolbarCheckedValueChangeData", [], ToolbarCheckedValueChangeData, () => [["checkedItems", array_type(string_type)], ["name", string_type]]);
}

export class PartitionAvatarGroupItems$1 extends Record {
    constructor(inlineItems, overflowItems) {
        super();
        this.inlineItems = inlineItems;
        this.overflowItems = overflowItems;
    }
}

export function PartitionAvatarGroupItems$1_$reflection(gen0) {
    return record_type("FS.FluentUI.PartitionAvatarGroupItems`1", [gen0], PartitionAvatarGroupItems$1, () => [["inlineItems", array_type(gen0)], ["overflowItems", array_type(gen0)]]);
}

export class DialogChange extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["escapeKeyDown", "backdropClick", "triggerClick"];
    }
}

export function DialogChange_$reflection() {
    return union_type("FS.FluentUI.DialogChange", [], DialogChange, () => [[], [], []]);
}

export class DialogOpenChangeData$1 extends Record {
    constructor(type, open, event) {
        super();
        this.type = type;
        this.open = open;
        this.event = event;
    }
}

export function DialogOpenChangeData$1_$reflection(gen0) {
    return record_type("FS.FluentUI.DialogOpenChangeData`1", [gen0], DialogOpenChangeData$1, () => [["type", DialogChange_$reflection()], ["open", bool_type], ["event", gen0]]);
}

export class FocusProp extends Record {
    constructor(focus) {
        super();
        this.focus = focus;
    }
}

export function FocusProp_$reflection() {
    return record_type("FS.FluentUI.FocusProp", [], FocusProp, () => [["focus", lambda_type(unit_type, unit_type)]]);
}

export class OverflowMenuOptions$1 extends Record {
    constructor(ref, overflowCount, isOverflowing) {
        super();
        this.ref = ref;
        this.overflowCount = (overflowCount | 0);
        this.isOverflowing = isOverflowing;
    }
}

export function OverflowMenuOptions$1_$reflection(gen0) {
    return record_type("FS.FluentUI.OverflowMenuOptions`1", [gen0], OverflowMenuOptions$1, () => [["ref", class_type("Fable.React.IRefValue`1", [option_type(gen0)])], ["overflowCount", int32_type], ["isOverflowing", bool_type]]);
}

export class OverflowVisibility extends Record {
    constructor(itemVisibility, groupVisibility) {
        super();
        this.itemVisibility = itemVisibility;
        this.groupVisibility = groupVisibility;
    }
}

export function OverflowVisibility_$reflection() {
    return record_type("FS.FluentUI.OverflowVisibility", [], OverflowVisibility, () => [["itemVisibility", obj_type], ["groupVisibility", obj_type]]);
}

export class OverflowGroupState extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["visible", "hidden", "overflow"];
    }
}

export function OverflowGroupState_$reflection() {
    return union_type("FS.FluentUI.OverflowGroupState", [], OverflowGroupState, () => [[], [], []]);
}

export class VirtualizerContextProps extends Record {
    constructor(contextIndex, setContextIndex) {
        super();
        this.contextIndex = (contextIndex | 0);
        this.setContextIndex = setContextIndex;
    }
}

export function VirtualizerContextProps_$reflection() {
    return record_type("FS.FluentUI.VirtualizerContextProps", [], VirtualizerContextProps, () => [["contextIndex", int32_type], ["setContextIndex", lambda_type(int32_type, unit_type)]]);
}

export class VirtualizerDataRef extends Record {
    constructor(progressiveSizes, nodeSizes, setFlaggedIndex, currentIndex) {
        super();
        this.progressiveSizes = progressiveSizes;
        this.nodeSizes = nodeSizes;
        this.setFlaggedIndex = setFlaggedIndex;
        this.currentIndex = currentIndex;
    }
}

export function VirtualizerDataRef_$reflection() {
    return record_type("FS.FluentUI.VirtualizerDataRef", [], VirtualizerDataRef, () => [["progressiveSizes", RefObject$1_$reflection(array_type(int32_type))], ["nodeSizes", RefObject$1_$reflection(array_type(int32_type))], ["setFlaggedIndex", lambda_type(option_type(int32_type), unit_type)], ["currentIndex", RefObject$1_$reflection(int32_type)]]);
}

export class MutableRefObject$1 extends Record {
    constructor(current) {
        super();
        this.current = current;
    }
}

export function MutableRefObject$1_$reflection(gen0) {
    return record_type("FS.FluentUI.MutableRefObject`1", [gen0], MutableRefObject$1, () => [["current", gen0]]);
}

export class VirtualizerMeasure extends Record {
    constructor(virtualizerLength, bufferItems, bufferSize, scrollRef, containerSizeRef) {
        super();
        this.virtualizerLength = (virtualizerLength | 0);
        this.bufferItems = (bufferItems | 0);
        this.bufferSize = (bufferSize | 0);
        this.scrollRef = scrollRef;
        this.containerSizeRef = containerSizeRef;
    }
}

export function VirtualizerMeasure_$reflection() {
    return record_type("FS.FluentUI.VirtualizerMeasure", [], VirtualizerMeasure, () => [["virtualizerLength", int32_type], ["bufferItems", int32_type], ["bufferSize", int32_type], ["scrollRef", lambda_type(class_type("Browser.Types.Element"), unit_type)], ["containerSizeRef", MutableRefObject$1_$reflection(int32_type)]]);
}

export class ScrollBehavior extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["auto", "instant", "smooth"];
    }
}

export function ScrollBehavior_$reflection() {
    return union_type("FS.FluentUI.ScrollBehavior", [], ScrollBehavior, () => [[], [], []]);
}

export class ScrollToInterface extends Record {
    constructor(scrollTo, virtualizerLength, currentIndex) {
        super();
        this.scrollTo = scrollTo;
        this.virtualizerLength = virtualizerLength;
        this.currentIndex = currentIndex;
    }
}

export function ScrollToInterface_$reflection() {
    return record_type("FS.FluentUI.ScrollToInterface", [], ScrollToInterface, () => [["scrollTo", lambda_type(int32_type, lambda_type(ScrollBehavior_$reflection(), lambda_type(lambda_type(int32_type, unit_type), unit_type)))], ["virtualizerLength", RefObject$1_$reflection(int32_type)], ["currentIndex", option_type(RefObject$1_$reflection(int32_type))]]);
}

export class AriaLivePoliteness extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["polite", "assertive"];
    }
}

export function AriaLivePoliteness_$reflection() {
    return union_type("FS.FluentUI.AriaLivePoliteness", [], AriaLivePoliteness, () => [[], []]);
}

export class AnnounceOptions extends Record {
    constructor(politeness) {
        super();
        this.politeness = politeness;
    }
}

export function AnnounceOptions_$reflection() {
    return record_type("FS.FluentUI.AnnounceOptions", [], AnnounceOptions, () => [["politeness", AriaLivePoliteness_$reflection()]]);
}

export class TempSeq$1 extends Record {
    constructor(selectedItems) {
        super();
        this.selectedItems = selectedItems;
    }
}

export function TempSeq$1_$reflection(gen0) {
    return record_type("FS.FluentUI.TempSeq`1", [gen0], TempSeq$1, () => [["selectedItems", class_type("System.Collections.Generic.IEnumerable`1", [gen0])]]);
}

export class OnSelectionChangeData$1 extends Record {
    constructor(selectedItems) {
        super();
        this.selectedItems = selectedItems;
    }
}

export function OnSelectionChangeData$1_$reflection(gen0) {
    return record_type("FS.FluentUI.OnSelectionChangeData`1", [gen0], OnSelectionChangeData$1, () => [["selectedItems", list_type(gen0)]]);
}

export function TempSeq_mkOnChangeData(v) {
    return new OnSelectionChangeData$1(ofSeq(v.selectedItems));
}

export class SortDirection extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["ascending", "descending"];
    }
}

export function SortDirection_$reflection() {
    return union_type("FS.FluentUI.SortDirection", [], SortDirection, () => [[], []]);
}

export class TableColumnSizingOptions extends Record {
    constructor(minWidth, idealWidth, padding, defaultWidth) {
        super();
        this.minWidth = (minWidth | 0);
        this.idealWidth = (idealWidth | 0);
        this.padding = (padding | 0);
        this.defaultWidth = (defaultWidth | 0);
    }
}

export function TableColumnSizingOptions_$reflection() {
    return record_type("FS.FluentUI.TableColumnSizingOptions", [], TableColumnSizingOptions, () => [["minWidth", int32_type], ["idealWidth", int32_type], ["padding", int32_type], ["defaultWidth", int32_type]]);
}

export class ColumnResizeData$1 extends Record {
    constructor(columnId, width) {
        super();
        this.columnId = columnId;
        this.width = (width | 0);
    }
}

export function ColumnResizeData$1_$reflection(gen0) {
    return record_type("FS.FluentUI.ColumnResizeData`1", [gen0], ColumnResizeData$1, () => [["columnId", gen0], ["width", int32_type]]);
}

export class TableSelectionMode extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["single", "multiselect"];
    }
}

export function TableSelectionMode_$reflection() {
    return union_type("FS.FluentUI.TableSelectionMode", [], TableSelectionMode, () => [[], []]);
}

export class TableRowData$2 extends Record {
    constructor(item, rowId) {
        super();
        this.item = item;
        this.rowId = rowId;
    }
}

export function TableRowData$2_$reflection(gen0, gen1) {
    return record_type("FS.FluentUI.TableRowData`2", [gen0, gen1], TableRowData$2, () => [["item", gen0], ["rowId", gen1]]);
}

export class TableColumnDefinition$2 extends Record {
    constructor(columnId, compare, renderHeaderCell, renderCell) {
        super();
        this.columnId = columnId;
        this.compare = compare;
        this.renderHeaderCell = renderHeaderCell;
        this.renderCell = renderCell;
    }
}

export function TableColumnDefinition$2_$reflection(gen0, gen1) {
    return record_type("FS.FluentUI.TableColumnDefinition`2", [gen0, gen1], TableColumnDefinition$2, () => [["columnId", gen1], ["compare", lambda_type(tuple_type(gen0, gen0), int32_type)], ["renderHeaderCell", lambda_type(unit_type, class_type("Fable.React.ReactElement", undefined))], ["renderCell", lambda_type(gen0, class_type("Fable.React.ReactElement", undefined))]]);
}

export class DataGridFocusMode extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["none", "cell", "row_unstable", "composite"];
    }
}

export function DataGridFocusMode_$reflection() {
    return union_type("FS.FluentUI.DataGridFocusMode", [], DataGridFocusMode, () => [[], [], [], []]);
}

export class Appearance extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["brand", "neutral", "none"];
    }
}

export function Appearance_$reflection() {
    return union_type("FS.FluentUI.Appearance", [], Appearance, () => [[], [], []]);
}

export class TableRowProps extends Record {
    constructor(appearance) {
        super();
        this.appearance = appearance;
    }
}

export function TableRowProps_$reflection() {
    return record_type("FS.FluentUI.TableRowProps", [], TableRowProps, () => [["appearance", Appearance_$reflection()]]);
}

export class FocusFinders extends Record {
    constructor(findAllFocusable, findFirstFocusable, findLastFocusable, findNextFocusable, findPrevFocusable) {
        super();
        this.findAllFocusable = findAllFocusable;
        this.findFirstFocusable = findFirstFocusable;
        this.findLastFocusable = findLastFocusable;
        this.findNextFocusable = findNextFocusable;
        this.findPrevFocusable = findPrevFocusable;
    }
}

export function FocusFinders_$reflection() {
    return record_type("FS.FluentUI.FocusFinders", [], FocusFinders, () => [["findAllFocusable", lambda_type(class_type("Browser.Types.HTMLElement"), lambda_type(option_type(lambda_type(class_type("Browser.Types.HTMLElement"), bool_type)), array_type(class_type("Browser.Types.HTMLElement"))))], ["findFirstFocusable", lambda_type(class_type("Browser.Types.HTMLElement"), option_type(class_type("Browser.Types.HTMLElement")))], ["findLastFocusable", lambda_type(class_type("Browser.Types.HTMLElement"), option_type(class_type("Browser.Types.HTMLElement")))], ["findNextFocusable", lambda_type(class_type("Browser.Types.HTMLElement"), lambda_type(class_type("Browser.Types.HTMLElement"), option_type(class_type("Browser.Types.HTMLElement"))))], ["findPrevFocusable", lambda_type(class_type("Browser.Types.HTMLElement"), lambda_type(class_type("Browser.Types.HTMLElement"), class_type("Browser.Types.HTMLElement")))]]);
}

export class DataGridContextValue extends Record {
    constructor(focusMode, selectableRows, subtleSelection, selectionAppearance, resizableColumns, compositeRowTabsterAttribute) {
        super();
        this.focusMode = focusMode;
        this.selectableRows = selectableRows;
        this.subtleSelection = subtleSelection;
        this.selectionAppearance = selectionAppearance;
        this.resizableColumns = resizableColumns;
        this.compositeRowTabsterAttribute = compositeRowTabsterAttribute;
    }
}

export function DataGridContextValue_$reflection() {
    return record_type("FS.FluentUI.DataGridContextValue", [], DataGridContextValue, () => [["focusMode", DataGridFocusMode_$reflection()], ["selectableRows", bool_type], ["subtleSelection", bool_type], ["selectionAppearance", TableRowProps_$reflection()], ["resizableColumns", option_type(bool_type)], ["compositeRowTabsterAttribute", obj_type]]);
}

export class ToasterShortcuts extends Record {
    constructor(focus) {
        super();
        this.focus = focus;
    }
}

export function ToasterShortcuts_$reflection() {
    return record_type("FS.FluentUI.ToasterShortcuts", [], ToasterShortcuts, () => [["focus", lambda_type(class_type("Browser.Types.KeyboardEvent"), bool_type)]]);
}

export class ToastOffset extends Record {
    constructor(horizontal, vertical) {
        super();
        this.horizontal = (horizontal | 0);
        this.vertical = (vertical | 0);
    }
}

export function ToastOffset_$reflection() {
    return record_type("FS.FluentUI.ToastOffset", [], ToastOffset, () => [["horizontal", int32_type], ["vertical", int32_type]]);
}

export class ToastPosition extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["top-end", "top-start", "bottom-end", "bottom-start"];
    }
}

export function ToastPosition_$reflection() {
    return union_type("FS.FluentUI.ToastPosition", [], ToastPosition, () => [[], [], [], []]);
}

export class ToastPoliteness extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["assertive", "polite"];
    }
}

export function ToastPoliteness_$reflection() {
    return union_type("FS.FluentUI.ToastPoliteness", [], ToastPoliteness, () => [[], []]);
}

export class ToastIntent extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["info", "success", "error", "warning"];
    }
}

export function ToastIntent_$reflection() {
    return union_type("FS.FluentUI.ToastIntent", [], ToastIntent, () => [[], [], [], []]);
}

export class ToastStatus extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["queued", "visible", "dismissed", "unmounted"];
    }
}

export function ToastStatus_$reflection() {
    return union_type("FS.FluentUI.ToastStatus", [], ToastStatus, () => [[], [], [], []]);
}

export class DispatchToastOptions extends Record {
    constructor(toastId, position, content, timeout, pauseOnWindowBlur, pauseOnHover, priority, politeness, intent, data, onStatusChange) {
        super();
        this.toastId = toastId;
        this.position = position;
        this.content = content;
        this.timeout = (timeout | 0);
        this.pauseOnWindowBlur = pauseOnWindowBlur;
        this.pauseOnHover = pauseOnHover;
        this.priority = (priority | 0);
        this.politeness = politeness;
        this.intent = intent;
        this.data = data;
        this.onStatusChange = onStatusChange;
    }
}

export function DispatchToastOptions_$reflection() {
    return record_type("FS.FluentUI.DispatchToastOptions", [], DispatchToastOptions, () => [["toastId", string_type], ["position", ToastPosition_$reflection()], ["content", class_type("Fable.React.ReactElement", undefined)], ["timeout", int32_type], ["pauseOnWindowBlur", bool_type], ["pauseOnHover", bool_type], ["priority", int32_type], ["politeness", ToastPoliteness_$reflection()], ["intent", ToastIntent_$reflection()], ["data", obj_type], ["onStatusChange", option_type(lambda_type(unit_type, lambda_type(ToastChangeData_$reflection(), unit_type)))]]);
}

export class ToastChangeData extends Record {
    constructor(root, toastId, position, content, timeout, pauseOnWindowBlur, pauseOnHover, toasterId, priority, politeness, intent, data, onStatusChange, status, updateId) {
        super();
        this.root = root;
        this.toastId = toastId;
        this.position = position;
        this.content = content;
        this.timeout = (timeout | 0);
        this.pauseOnWindowBlur = pauseOnWindowBlur;
        this.pauseOnHover = pauseOnHover;
        this.toasterId = toasterId;
        this.priority = (priority | 0);
        this.politeness = politeness;
        this.intent = intent;
        this.data = data;
        this.onStatusChange = onStatusChange;
        this.status = status;
        this.updateId = (updateId | 0);
    }
}

export function ToastChangeData_$reflection() {
    return record_type("FS.FluentUI.ToastChangeData", [], ToastChangeData, () => [["root", option_type(list_type(class_type("Feliz.IReactProperty")))], ["toastId", string_type], ["position", ToastPosition_$reflection()], ["content", class_type("Fable.React.ReactElement", undefined)], ["timeout", int32_type], ["pauseOnWindowBlur", bool_type], ["pauseOnHover", bool_type], ["toasterId", string_type], ["priority", int32_type], ["politeness", ToastPoliteness_$reflection()], ["intent", ToastIntent_$reflection()], ["data", obj_type], ["onStatusChange", option_type(lambda_type(class_type("Browser.Types.MouseEvent"), lambda_type(ToastChangeData_$reflection(), unit_type)))], ["status", ToastStatus_$reflection()], ["updateId", int32_type]]);
}

export class UpdateToastOptions extends Record {
    constructor(root, toastId, position, content, timeout, pauseOnWindowBlur, pauseOnHover, toasterId, priority, politeness, intent, data, onStatusChange) {
        super();
        this.root = root;
        this.toastId = toastId;
        this.position = position;
        this.content = content;
        this.timeout = (timeout | 0);
        this.pauseOnWindowBlur = pauseOnWindowBlur;
        this.pauseOnHover = pauseOnHover;
        this.toasterId = toasterId;
        this.priority = (priority | 0);
        this.politeness = politeness;
        this.intent = intent;
        this.data = data;
        this.onStatusChange = onStatusChange;
    }
}

export function UpdateToastOptions_$reflection() {
    return record_type("FS.FluentUI.UpdateToastOptions", [], UpdateToastOptions, () => [["root", list_type(class_type("Feliz.IReactProperty"))], ["toastId", string_type], ["position", ToastPosition_$reflection()], ["content", class_type("Fable.React.ReactElement", undefined)], ["timeout", int32_type], ["pauseOnWindowBlur", bool_type], ["pauseOnHover", bool_type], ["toasterId", string_type], ["priority", int32_type], ["politeness", ToastPoliteness_$reflection()], ["intent", ToastIntent_$reflection()], ["data", obj_type], ["onStatusChange", option_type(lambda_type(class_type("Browser.Types.MouseEvent"), lambda_type(ToastChangeData_$reflection(), unit_type)))]]);
}

export class ToastController extends Record {
    constructor(dispatchToast, dismissToast, dismissAllToasts, updateToast, pauseToast, playToast) {
        super();
        this.dispatchToast = dispatchToast;
        this.dismissToast = dismissToast;
        this.dismissAllToasts = dismissAllToasts;
        this.updateToast = updateToast;
        this.pauseToast = pauseToast;
        this.playToast = playToast;
    }
}

export function ToastController_$reflection() {
    return record_type("FS.FluentUI.ToastController", [], ToastController, () => [["dispatchToast", lambda_type(tuple_type(class_type("Fable.React.ReactElement", undefined), list_type(string_type)), unit_type)], ["dismissToast", lambda_type(string_type, unit_type)], ["dismissAllToasts", lambda_type(unit_type, unit_type)], ["updateToast", lambda_type(list_type(string_type), unit_type)], ["pauseToast", lambda_type(string_type, unit_type)], ["playToast", lambda_type(string_type, unit_type)]]);
}

export class DateRangeType extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Day", "Week", "Month", "WorkWeek"];
    }
}

export function DateRangeType_$reflection() {
    return union_type("FS.FluentUI.DateRangeType", [], DateRangeType, () => [[], [], [], []]);
}

export class DatePickerErrorType extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["invalid-input", "out-of-bounds", "required-input"];
    }
}

export function DatePickerErrorType_$reflection() {
    return union_type("FS.FluentUI.DatePickerErrorType", [], DatePickerErrorType, () => [[], [], []]);
}

export class DatePickerValidationResultData extends Record {
    constructor(error) {
        super();
        this.error = error;
    }
}

export function DatePickerValidationResultData_$reflection() {
    return record_type("FS.FluentUI.DatePickerValidationResultData", [], DatePickerValidationResultData, () => [["error", option_type(DatePickerErrorType_$reflection())]]);
}

export function DatePickerValidationResultDataModule_fromString(result) {
    const matchValue = result.error;
    let matchResult;
    if (matchValue != null) {
        switch (matchValue) {
            case "invalid-input": {
                matchResult = 0;
                break;
            }
            case "out-of-bounds": {
                matchResult = 1;
                break;
            }
            case "required-input": {
                matchResult = 2;
                break;
            }
            default:
                matchResult = 3;
        }
    }
    else {
        matchResult = 3;
    }
    switch (matchResult) {
        case 0:
            return new DatePickerValidationResultData(new DatePickerErrorType(0, []));
        case 1:
            return new DatePickerValidationResultData(new DatePickerErrorType(1, []));
        case 2:
            return new DatePickerValidationResultData(new DatePickerErrorType(2, []));
        default:
            return new DatePickerValidationResultData(undefined);
    }
}

export class DatePickerErrorStrings extends Record {
    constructor(invalid$002Dinput, out$002Dof$002Dbounds, required$002Dinput) {
        super();
        this["invalid-input"] = invalid$002Dinput;
        this["out-of-bounds"] = out$002Dof$002Dbounds;
        this["required-input"] = required$002Dinput;
    }
}

export function DatePickerErrorStrings_$reflection() {
    return record_type("FS.FluentUI.DatePickerErrorStrings", [], DatePickerErrorStrings, () => [["invalid-input", string_type], ["out-of-bounds", string_type], ["required-input", string_type]]);
}

export function DatePickerErrorStringsModule_fromErrorTypeOption(error) {
    if (error != null) {
        switch (error.tag) {
            case 1:
                return "Date is out of bounds";
            case 2:
                return "Field is required";
            default:
                return "Invalid date format";
        }
    }
    else {
        return "";
    }
}

export class DateGridStrings extends Record {
    constructor(months, shortMonths, days, shortDays) {
        super();
        this.months = months;
        this.shortMonths = shortMonths;
        this.days = days;
        this.shortDays = shortDays;
    }
}

export function DateGridStrings_$reflection() {
    return record_type("FS.FluentUI.DateGridStrings", [], DateGridStrings, () => [["months", array_type(string_type)], ["shortMonths", array_type(string_type)], ["days", array_type(string_type)], ["shortDays", array_type(string_type)]]);
}

export class DateFormatting extends Record {
    constructor(formatDay, formatMonth, formatYear, formatMonthDayYear, formatMonthYear) {
        super();
        this.formatDay = formatDay;
        this.formatMonth = formatMonth;
        this.formatYear = formatYear;
        this.formatMonthDayYear = formatMonthDayYear;
        this.formatMonthYear = formatMonthYear;
    }
}

export function DateFormatting_$reflection() {
    return record_type("FS.FluentUI.DateFormatting", [], DateFormatting, () => [["formatDay", lambda_type(class_type("System.DateTime"), string_type)], ["formatMonth", lambda_type(class_type("System.DateTime"), lambda_type(DateGridStrings_$reflection(), string_type))], ["formatYear", lambda_type(class_type("System.DateTime"), string_type)], ["formatMonthDayYear", lambda_type(class_type("System.DateTime"), lambda_type(DateGridStrings_$reflection(), string_type))], ["formatMonthYear", lambda_type(class_type("System.DateTime"), lambda_type(DateGridStrings_$reflection(), string_type))]]);
}

export class CalendarStrings extends Record {
    constructor(goToToday, prevMonthAriaLabel, nextMonthAriaLabel, prevYearAriaLabel, nextYearAriaLabel, prevYearRangeAriaLabel, nextYearRangeAriaLabel, monthPickerHeaderAriaLabel, yearPickerHeaderAriaLabel, closeButtonAriaLabel, weekNumberFormatString, selectedDateFormatString, todayDateFormatString, dayMarkedAriaLabel, months, shortMonths, days, shortDays) {
        super();
        this.goToToday = goToToday;
        this.prevMonthAriaLabel = prevMonthAriaLabel;
        this.nextMonthAriaLabel = nextMonthAriaLabel;
        this.prevYearAriaLabel = prevYearAriaLabel;
        this.nextYearAriaLabel = nextYearAriaLabel;
        this.prevYearRangeAriaLabel = prevYearRangeAriaLabel;
        this.nextYearRangeAriaLabel = nextYearRangeAriaLabel;
        this.monthPickerHeaderAriaLabel = monthPickerHeaderAriaLabel;
        this.yearPickerHeaderAriaLabel = yearPickerHeaderAriaLabel;
        this.closeButtonAriaLabel = closeButtonAriaLabel;
        this.weekNumberFormatString = weekNumberFormatString;
        this.selectedDateFormatString = selectedDateFormatString;
        this.todayDateFormatString = todayDateFormatString;
        this.dayMarkedAriaLabel = dayMarkedAriaLabel;
        this.months = months;
        this.shortMonths = shortMonths;
        this.days = days;
        this.shortDays = shortDays;
    }
}

export function CalendarStrings_$reflection() {
    return record_type("FS.FluentUI.CalendarStrings", [], CalendarStrings, () => [["goToToday", string_type], ["prevMonthAriaLabel", option_type(string_type)], ["nextMonthAriaLabel", option_type(string_type)], ["prevYearAriaLabel", option_type(string_type)], ["nextYearAriaLabel", option_type(string_type)], ["prevYearRangeAriaLabel", option_type(string_type)], ["nextYearRangeAriaLabel", option_type(string_type)], ["monthPickerHeaderAriaLabel", option_type(string_type)], ["yearPickerHeaderAriaLabel", option_type(string_type)], ["closeButtonAriaLabel", option_type(string_type)], ["weekNumberFormatString", option_type(string_type)], ["selectedDateFormatString", option_type(string_type)], ["todayDateFormatString", option_type(string_type)], ["dayMarkedAriaLabel", option_type(string_type)], ["months", array_type(string_type)], ["shortMonths", array_type(string_type)], ["days", array_type(string_type)], ["shortDays", array_type(string_type)]]);
}

export class CalendarDayGridStyles extends Record {
    constructor(wrapper, table, dayCell, daySelected, weekRow, weekDayLabelCell, weekNumberCell, dayOutsideBounds, dayOutsideNavigatedMonth, dayButton, dayIsToday, firstTransitionWeek, lastTransitionWeek, dayMarker) {
        super();
        this.wrapper = wrapper;
        this.table = table;
        this.dayCell = dayCell;
        this.daySelected = daySelected;
        this.weekRow = weekRow;
        this.weekDayLabelCell = weekDayLabelCell;
        this.weekNumberCell = weekNumberCell;
        this.dayOutsideBounds = dayOutsideBounds;
        this.dayOutsideNavigatedMonth = dayOutsideNavigatedMonth;
        this.dayButton = dayButton;
        this.dayIsToday = dayIsToday;
        this.firstTransitionWeek = firstTransitionWeek;
        this.lastTransitionWeek = lastTransitionWeek;
        this.dayMarker = dayMarker;
    }
}

export function CalendarDayGridStyles_$reflection() {
    return record_type("FS.FluentUI.CalendarDayGridStyles", [], CalendarDayGridStyles, () => [["wrapper", string_type], ["table", string_type], ["dayCell", string_type], ["daySelected", string_type], ["weekRow", string_type], ["weekDayLabelCell", string_type], ["weekNumberCell", string_type], ["dayOutsideBounds", string_type], ["dayOutsideNavigatedMonth", string_type], ["dayButton", string_type], ["dayIsToday", string_type], ["firstTransitionWeek", string_type], ["lastTransitionWeek", string_type], ["dayMarker", string_type]]);
}

export class FirstWeekOfYear extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["FirstDay", "FirstFullWeek", "FirstFourDayWeek"];
    }
}

export function FirstWeekOfYear_$reflection() {
    return union_type("FS.FluentUI.FirstWeekOfYear", [], FirstWeekOfYear, () => [[], [], []]);
}

export class MakeStyle extends Record {
    constructor(displayName, styles) {
        super();
        this.displayName = displayName;
        this.styles = styles;
    }
}

export function MakeStyle_$reflection() {
    return record_type("FS.FluentUI.MakeStyle", [], MakeStyle, () => [["displayName", string_type], ["styles", list_type(class_type("Feliz.IStyleAttribute"))]]);
}

export class BrandVariants extends Record {
    constructor($00310, $00320, $00330, $00340, $00350, $00360, $00370, $00380, $00390, $003100, $003110, $003120, $003130, $003140, $003150, $003160) {
        super();
        this["10"] = $00310;
        this["20"] = $00320;
        this["30"] = $00330;
        this["40"] = $00340;
        this["50"] = $00350;
        this["60"] = $00360;
        this["70"] = $00370;
        this["80"] = $00380;
        this["90"] = $00390;
        this["100"] = $003100;
        this["110"] = $003110;
        this["120"] = $003120;
        this["130"] = $003130;
        this["140"] = $003140;
        this["150"] = $003150;
        this["160"] = $003160;
    }
}

export function BrandVariants_$reflection() {
    return record_type("FS.FluentUI.BrandVariants", [], BrandVariants, () => [["10", string_type], ["20", string_type], ["30", string_type], ["40", string_type], ["50", string_type], ["60", string_type], ["70", string_type], ["80", string_type], ["90", string_type], ["100", string_type], ["110", string_type], ["120", string_type], ["130", string_type], ["140", string_type], ["150", string_type], ["160", string_type]]);
}

export class Tokens extends Record {
    constructor(borderRadiusNone, borderRadiusSmall, borderRadiusMedium, borderRadiusLarge, borderRadiusXLarge, borderRadiusCircular, fontSizeBase100, fontSizeBase200, fontSizeBase300, fontSizeBase400, fontSizeBase500, fontSizeBase600, fontSizeHero700, fontSizeHero800, fontSizeHero900, fontSizeHero1000, lineHeightBase100, lineHeightBase200, lineHeightBase300, lineHeightBase400, lineHeightBase500, lineHeightBase600, lineHeightHero700, lineHeightHero800, lineHeightHero900, lineHeightHero1000, fontFamilyBase, fontFamilyMonospace, fontFamilyNumeric, fontWeightRegular, fontWeightMedium, fontWeightSemibold, fontWeightBold, strokeWidthThin, strokeWidthThick, strokeWidthThicker, strokeWidthThickest, spacingHorizontalNone, spacingHorizontalXXS, spacingHorizontalXS, spacingHorizontalSNudge, spacingHorizontalS, spacingHorizontalMNudge, spacingHorizontalM, spacingHorizontalL, spacingHorizontalXL, spacingHorizontalXXL, spacingHorizontalXXXL, spacingVerticalNone, spacingVerticalXXS, spacingVerticalXS, spacingVerticalSNudge, spacingVerticalS, spacingVerticalMNudge, spacingVerticalM, spacingVerticalL, spacingVerticalXL, spacingVerticalXXL, spacingVerticalXXXL, durationUltraFast, durationFaster, durationFast, durationNormal, durationGentle, durationSlow, durationSlower, durationUltraSlow, curveAccelerateMax, curveAccelerateMid, curveAccelerateMin, curveDecelerateMax, curveDecelerateMid, curveDecelerateMin, curveEasyEaseMax, curveEasyEase, curveLinear, colorNeutralForeground1, colorNeutralForeground1Hover, colorNeutralForeground1Pressed, colorNeutralForeground1Selected, colorNeutralForeground2, colorNeutralForeground2Hover, colorNeutralForeground2Pressed, colorNeutralForeground2Selected, colorNeutralForeground2BrandHover, colorNeutralForeground2BrandPressed, colorNeutralForeground2BrandSelected, colorNeutralForeground3, colorNeutralForeground3Hover, colorNeutralForeground3Pressed, colorNeutralForeground3Selected, colorNeutralForeground3BrandHover, colorNeutralForeground3BrandPressed, colorNeutralForeground3BrandSelected, colorNeutralForeground4, colorNeutralForegroundDisabled, colorNeutralForegroundInvertedDisabled, colorBrandForegroundLink, colorBrandForegroundLinkHover, colorBrandForegroundLinkPressed, colorBrandForegroundLinkSelected, colorNeutralForeground2Link, colorNeutralForeground2LinkHover, colorNeutralForeground2LinkPressed, colorNeutralForeground2LinkSelected, colorCompoundBrandForeground1, colorCompoundBrandForeground1Hover, colorCompoundBrandForeground1Pressed, colorBrandForeground1, colorBrandForeground2, colorBrandForeground2Hover, colorBrandForeground2Pressed, colorNeutralForeground1Static, colorNeutralForegroundStaticInverted, colorNeutralForegroundInverted, colorNeutralForegroundInvertedHover, colorNeutralForegroundInvertedPressed, colorNeutralForegroundInvertedSelected, colorNeutralForegroundInverted2, colorNeutralForegroundOnBrand, colorNeutralForegroundInvertedLink, colorNeutralForegroundInvertedLinkHover, colorNeutralForegroundInvertedLinkPressed, colorNeutralForegroundInvertedLinkSelected, colorBrandForegroundInverted, colorBrandForegroundInvertedHover, colorBrandForegroundInvertedPressed, colorBrandForegroundOnLight, colorBrandForegroundOnLightHover, colorBrandForegroundOnLightPressed, colorBrandForegroundOnLightSelected, colorNeutralBackground1, colorNeutralBackground1Hover, colorNeutralBackground1Pressed, colorNeutralBackground1Selected, colorNeutralBackground2, colorNeutralBackground2Hover, colorNeutralBackground2Pressed, colorNeutralBackground2Selected, colorNeutralBackground3, colorNeutralBackground3Hover, colorNeutralBackground3Pressed, colorNeutralBackground3Selected, colorNeutralBackground4, colorNeutralBackground4Hover, colorNeutralBackground4Pressed, colorNeutralBackground4Selected, colorNeutralBackground5, colorNeutralBackground5Hover, colorNeutralBackground5Pressed, colorNeutralBackground5Selected, colorNeutralBackground6, colorNeutralBackgroundInverted, colorNeutralBackgroundStatic, colorNeutralBackgroundAlpha, colorNeutralBackgroundAlpha2, colorSubtleBackground, colorSubtleBackgroundHover, colorSubtleBackgroundPressed, colorSubtleBackgroundSelected, colorSubtleBackgroundLightAlphaHover, colorSubtleBackgroundLightAlphaPressed, colorSubtleBackgroundLightAlphaSelected, colorSubtleBackgroundInverted, colorSubtleBackgroundInvertedHover, colorSubtleBackgroundInvertedPressed, colorSubtleBackgroundInvertedSelected, colorTransparentBackground, colorTransparentBackgroundHover, colorTransparentBackgroundPressed, colorTransparentBackgroundSelected, colorNeutralBackgroundDisabled, colorNeutralBackgroundInvertedDisabled, colorNeutralStencil1, colorNeutralStencil2, colorNeutralStencil1Alpha, colorNeutralStencil2Alpha, colorBackgroundOverlay, colorScrollbarOverlay, colorBrandBackground, colorBrandBackgroundHover, colorBrandBackgroundPressed, colorBrandBackgroundSelected, colorCompoundBrandBackground, colorCompoundBrandBackgroundHover, colorCompoundBrandBackgroundPressed, colorBrandBackgroundStatic, colorBrandBackground2, colorBrandBackground2Hover, colorBrandBackground2Pressed, colorBrandBackground3Static, colorBrandBackground4Static, colorBrandBackgroundInverted, colorBrandBackgroundInvertedHover, colorBrandBackgroundInvertedPressed, colorBrandBackgroundInvertedSelected, colorNeutralCardBackground, colorNeutralCardBackgroundHover, colorNeutralCardBackgroundPressed, colorNeutralCardBackgroundSelected, colorNeutralCardBackgroundDisabled, colorNeutralStrokeAccessible, colorNeutralStrokeAccessibleHover, colorNeutralStrokeAccessiblePressed, colorNeutralStrokeAccessibleSelected, colorNeutralStroke1, colorNeutralStroke1Hover, colorNeutralStroke1Pressed, colorNeutralStroke1Selected, colorNeutralStroke2, colorNeutralStroke3, colorNeutralStrokeSubtle, colorNeutralStrokeOnBrand, colorNeutralStrokeOnBrand2, colorNeutralStrokeOnBrand2Hover, colorNeutralStrokeOnBrand2Pressed, colorNeutralStrokeOnBrand2Selected, colorBrandStroke1, colorBrandStroke2, colorBrandStroke2Hover, colorBrandStroke2Pressed, colorBrandStroke2Contrast, colorCompoundBrandStroke, colorCompoundBrandStrokeHover, colorCompoundBrandStrokePressed, colorNeutralStrokeDisabled, colorNeutralStrokeInvertedDisabled, colorTransparentStroke, colorTransparentStrokeInteractive, colorTransparentStrokeDisabled, colorNeutralStrokeAlpha, colorNeutralStrokeAlpha2, colorStrokeFocus1, colorStrokeFocus2, colorNeutralShadowAmbient, colorNeutralShadowKey, colorNeutralShadowAmbientLighter, colorNeutralShadowKeyLighter, colorNeutralShadowAmbientDarker, colorNeutralShadowKeyDarker, colorBrandShadowAmbient, colorBrandShadowKey, colorPaletteRedBackground1, colorPaletteRedBackground2, colorPaletteRedBackground3, colorPaletteRedForeground1, colorPaletteRedForeground2, colorPaletteRedForeground3, colorPaletteRedBorderActive, colorPaletteRedBorder1, colorPaletteRedBorder2, colorPaletteGreenBackground1, colorPaletteGreenBackground2, colorPaletteGreenBackground3, colorPaletteGreenForeground1, colorPaletteGreenForeground2, colorPaletteGreenForeground3, colorPaletteGreenBorderActive, colorPaletteGreenBorder1, colorPaletteGreenBorder2, colorPaletteDarkOrangeBackground1, colorPaletteDarkOrangeBackground2, colorPaletteDarkOrangeBackground3, colorPaletteDarkOrangeForeground1, colorPaletteDarkOrangeForeground2, colorPaletteDarkOrangeForeground3, colorPaletteDarkOrangeBorderActive, colorPaletteDarkOrangeBorder1, colorPaletteDarkOrangeBorder2, colorPaletteYellowBackground1, colorPaletteYellowBackground2, colorPaletteYellowBackground3, colorPaletteYellowForeground1, colorPaletteYellowForeground2, colorPaletteYellowForeground3, colorPaletteYellowBorderActive, colorPaletteYellowBorder1, colorPaletteYellowBorder2, colorPaletteBerryBackground1, colorPaletteBerryBackground2, colorPaletteBerryBackground3, colorPaletteBerryForeground1, colorPaletteBerryForeground2, colorPaletteBerryForeground3, colorPaletteBerryBorderActive, colorPaletteBerryBorder1, colorPaletteBerryBorder2, colorPaletteLightGreenBackground1, colorPaletteLightGreenBackground2, colorPaletteLightGreenBackground3, colorPaletteLightGreenForeground1, colorPaletteLightGreenForeground2, colorPaletteLightGreenForeground3, colorPaletteLightGreenBorderActive, colorPaletteLightGreenBorder1, colorPaletteLightGreenBorder2, colorPaletteMarigoldBackground1, colorPaletteMarigoldBackground2, colorPaletteMarigoldBackground3, colorPaletteMarigoldForeground1, colorPaletteMarigoldForeground2, colorPaletteMarigoldForeground3, colorPaletteMarigoldBorderActive, colorPaletteMarigoldBorder1, colorPaletteMarigoldBorder2, colorPaletteRedForegroundInverted, colorPaletteGreenForegroundInverted, colorPaletteYellowForegroundInverted, colorPaletteDarkRedBackground2, colorPaletteDarkRedForeground2, colorPaletteDarkRedBorderActive, colorPaletteCranberryBackground2, colorPaletteCranberryForeground2, colorPaletteCranberryBorderActive, colorPalettePumpkinBackground2, colorPalettePumpkinForeground2, colorPalettePumpkinBorderActive, colorPalettePeachBackground2, colorPalettePeachForeground2, colorPalettePeachBorderActive, colorPaletteGoldBackground2, colorPaletteGoldForeground2, colorPaletteGoldBorderActive, colorPaletteBrassBackground2, colorPaletteBrassForeground2, colorPaletteBrassBorderActive, colorPaletteBrownBackground2, colorPaletteBrownForeground2, colorPaletteBrownBorderActive, colorPaletteForestBackground2, colorPaletteForestForeground2, colorPaletteForestBorderActive, colorPaletteSeafoamBackground2, colorPaletteSeafoamForeground2, colorPaletteSeafoamBorderActive, colorPaletteDarkGreenBackground2, colorPaletteDarkGreenForeground2, colorPaletteDarkGreenBorderActive, colorPaletteLightTealBackground2, colorPaletteLightTealForeground2, colorPaletteLightTealBorderActive, colorPaletteTealBackground2, colorPaletteTealForeground2, colorPaletteTealBorderActive, colorPaletteSteelBackground2, colorPaletteSteelForeground2, colorPaletteSteelBorderActive, colorPaletteBlueBackground2, colorPaletteBlueForeground2, colorPaletteBlueBorderActive, colorPaletteRoyalBlueBackground2, colorPaletteRoyalBlueForeground2, colorPaletteRoyalBlueBorderActive, colorPaletteCornflowerBackground2, colorPaletteCornflowerForeground2, colorPaletteCornflowerBorderActive, colorPaletteNavyBackground2, colorPaletteNavyForeground2, colorPaletteNavyBorderActive, colorPaletteLavenderBackground2, colorPaletteLavenderForeground2, colorPaletteLavenderBorderActive, colorPalettePurpleBackground2, colorPalettePurpleForeground2, colorPalettePurpleBorderActive, colorPaletteGrapeBackground2, colorPaletteGrapeForeground2, colorPaletteGrapeBorderActive, colorPaletteLilacBackground2, colorPaletteLilacForeground2, colorPaletteLilacBorderActive, colorPalettePinkBackground2, colorPalettePinkForeground2, colorPalettePinkBorderActive, colorPaletteMagentaBackground2, colorPaletteMagentaForeground2, colorPaletteMagentaBorderActive, colorPalettePlumBackground2, colorPalettePlumForeground2, colorPalettePlumBorderActive, colorPaletteBeigeBackground2, colorPaletteBeigeForeground2, colorPaletteBeigeBorderActive, colorPaletteMinkBackground2, colorPaletteMinkForeground2, colorPaletteMinkBorderActive, colorPalettePlatinumBackground2, colorPalettePlatinumForeground2, colorPalettePlatinumBorderActive, colorPaletteAnchorBackground2, colorPaletteAnchorForeground2, colorPaletteAnchorBorderActive, colorStatusSuccessBackground1, colorStatusSuccessBackground2, colorStatusSuccessBackground3, colorStatusSuccessForeground1, colorStatusSuccessForeground2, colorStatusSuccessForeground3, colorStatusSuccessBorderActive, colorStatusSuccessForegroundInverted, colorStatusSuccessBorder1, colorStatusSuccessBorder2, colorStatusWarningBackground1, colorStatusWarningBackground2, colorStatusWarningBackground3, colorStatusWarningForeground1, colorStatusWarningForeground2, colorStatusWarningForeground3, colorStatusWarningBorderActive, colorStatusWarningForegroundInverted, colorStatusWarningBorder1, colorStatusWarningBorder2, colorStatusDangerBackground1, colorStatusDangerBackground2, colorStatusDangerBackground3, colorStatusDangerForeground1, colorStatusDangerForeground2, colorStatusDangerForeground3, colorStatusDangerBorderActive, colorStatusDangerForegroundInverted, colorStatusDangerBorder1, colorStatusDangerBorder2, shadow2, shadow4, shadow8, shadow16, shadow28, shadow64, shadow2Brand, shadow4Brand, shadow8Brand, shadow16Brand, shadow28Brand, shadow64Brand, zIndexBackground, zIndexContent, zIndexOverlay, zIndexPopup, zIndexMessages, zIndexFloating, zIndexPriority, zIndexDebug) {
        super();
        this.borderRadiusNone = borderRadiusNone;
        this.borderRadiusSmall = borderRadiusSmall;
        this.borderRadiusMedium = borderRadiusMedium;
        this.borderRadiusLarge = borderRadiusLarge;
        this.borderRadiusXLarge = borderRadiusXLarge;
        this.borderRadiusCircular = borderRadiusCircular;
        this.fontSizeBase100 = fontSizeBase100;
        this.fontSizeBase200 = fontSizeBase200;
        this.fontSizeBase300 = fontSizeBase300;
        this.fontSizeBase400 = fontSizeBase400;
        this.fontSizeBase500 = fontSizeBase500;
        this.fontSizeBase600 = fontSizeBase600;
        this.fontSizeHero700 = fontSizeHero700;
        this.fontSizeHero800 = fontSizeHero800;
        this.fontSizeHero900 = fontSizeHero900;
        this.fontSizeHero1000 = fontSizeHero1000;
        this.lineHeightBase100 = lineHeightBase100;
        this.lineHeightBase200 = lineHeightBase200;
        this.lineHeightBase300 = lineHeightBase300;
        this.lineHeightBase400 = lineHeightBase400;
        this.lineHeightBase500 = lineHeightBase500;
        this.lineHeightBase600 = lineHeightBase600;
        this.lineHeightHero700 = lineHeightHero700;
        this.lineHeightHero800 = lineHeightHero800;
        this.lineHeightHero900 = lineHeightHero900;
        this.lineHeightHero1000 = lineHeightHero1000;
        this.fontFamilyBase = fontFamilyBase;
        this.fontFamilyMonospace = fontFamilyMonospace;
        this.fontFamilyNumeric = fontFamilyNumeric;
        this.fontWeightRegular = (fontWeightRegular | 0);
        this.fontWeightMedium = (fontWeightMedium | 0);
        this.fontWeightSemibold = (fontWeightSemibold | 0);
        this.fontWeightBold = (fontWeightBold | 0);
        this.strokeWidthThin = strokeWidthThin;
        this.strokeWidthThick = strokeWidthThick;
        this.strokeWidthThicker = strokeWidthThicker;
        this.strokeWidthThickest = strokeWidthThickest;
        this.spacingHorizontalNone = spacingHorizontalNone;
        this.spacingHorizontalXXS = spacingHorizontalXXS;
        this.spacingHorizontalXS = spacingHorizontalXS;
        this.spacingHorizontalSNudge = spacingHorizontalSNudge;
        this.spacingHorizontalS = spacingHorizontalS;
        this.spacingHorizontalMNudge = spacingHorizontalMNudge;
        this.spacingHorizontalM = spacingHorizontalM;
        this.spacingHorizontalL = spacingHorizontalL;
        this.spacingHorizontalXL = spacingHorizontalXL;
        this.spacingHorizontalXXL = spacingHorizontalXXL;
        this.spacingHorizontalXXXL = spacingHorizontalXXXL;
        this.spacingVerticalNone = spacingVerticalNone;
        this.spacingVerticalXXS = spacingVerticalXXS;
        this.spacingVerticalXS = spacingVerticalXS;
        this.spacingVerticalSNudge = spacingVerticalSNudge;
        this.spacingVerticalS = spacingVerticalS;
        this.spacingVerticalMNudge = spacingVerticalMNudge;
        this.spacingVerticalM = spacingVerticalM;
        this.spacingVerticalL = spacingVerticalL;
        this.spacingVerticalXL = spacingVerticalXL;
        this.spacingVerticalXXL = spacingVerticalXXL;
        this.spacingVerticalXXXL = spacingVerticalXXXL;
        this.durationUltraFast = durationUltraFast;
        this.durationFaster = durationFaster;
        this.durationFast = durationFast;
        this.durationNormal = durationNormal;
        this.durationGentle = durationGentle;
        this.durationSlow = durationSlow;
        this.durationSlower = durationSlower;
        this.durationUltraSlow = durationUltraSlow;
        this.curveAccelerateMax = curveAccelerateMax;
        this.curveAccelerateMid = curveAccelerateMid;
        this.curveAccelerateMin = curveAccelerateMin;
        this.curveDecelerateMax = curveDecelerateMax;
        this.curveDecelerateMid = curveDecelerateMid;
        this.curveDecelerateMin = curveDecelerateMin;
        this.curveEasyEaseMax = curveEasyEaseMax;
        this.curveEasyEase = curveEasyEase;
        this.curveLinear = curveLinear;
        this.colorNeutralForeground1 = colorNeutralForeground1;
        this.colorNeutralForeground1Hover = colorNeutralForeground1Hover;
        this.colorNeutralForeground1Pressed = colorNeutralForeground1Pressed;
        this.colorNeutralForeground1Selected = colorNeutralForeground1Selected;
        this.colorNeutralForeground2 = colorNeutralForeground2;
        this.colorNeutralForeground2Hover = colorNeutralForeground2Hover;
        this.colorNeutralForeground2Pressed = colorNeutralForeground2Pressed;
        this.colorNeutralForeground2Selected = colorNeutralForeground2Selected;
        this.colorNeutralForeground2BrandHover = colorNeutralForeground2BrandHover;
        this.colorNeutralForeground2BrandPressed = colorNeutralForeground2BrandPressed;
        this.colorNeutralForeground2BrandSelected = colorNeutralForeground2BrandSelected;
        this.colorNeutralForeground3 = colorNeutralForeground3;
        this.colorNeutralForeground3Hover = colorNeutralForeground3Hover;
        this.colorNeutralForeground3Pressed = colorNeutralForeground3Pressed;
        this.colorNeutralForeground3Selected = colorNeutralForeground3Selected;
        this.colorNeutralForeground3BrandHover = colorNeutralForeground3BrandHover;
        this.colorNeutralForeground3BrandPressed = colorNeutralForeground3BrandPressed;
        this.colorNeutralForeground3BrandSelected = colorNeutralForeground3BrandSelected;
        this.colorNeutralForeground4 = colorNeutralForeground4;
        this.colorNeutralForegroundDisabled = colorNeutralForegroundDisabled;
        this.colorNeutralForegroundInvertedDisabled = colorNeutralForegroundInvertedDisabled;
        this.colorBrandForegroundLink = colorBrandForegroundLink;
        this.colorBrandForegroundLinkHover = colorBrandForegroundLinkHover;
        this.colorBrandForegroundLinkPressed = colorBrandForegroundLinkPressed;
        this.colorBrandForegroundLinkSelected = colorBrandForegroundLinkSelected;
        this.colorNeutralForeground2Link = colorNeutralForeground2Link;
        this.colorNeutralForeground2LinkHover = colorNeutralForeground2LinkHover;
        this.colorNeutralForeground2LinkPressed = colorNeutralForeground2LinkPressed;
        this.colorNeutralForeground2LinkSelected = colorNeutralForeground2LinkSelected;
        this.colorCompoundBrandForeground1 = colorCompoundBrandForeground1;
        this.colorCompoundBrandForeground1Hover = colorCompoundBrandForeground1Hover;
        this.colorCompoundBrandForeground1Pressed = colorCompoundBrandForeground1Pressed;
        this.colorBrandForeground1 = colorBrandForeground1;
        this.colorBrandForeground2 = colorBrandForeground2;
        this.colorBrandForeground2Hover = colorBrandForeground2Hover;
        this.colorBrandForeground2Pressed = colorBrandForeground2Pressed;
        this.colorNeutralForeground1Static = colorNeutralForeground1Static;
        this.colorNeutralForegroundStaticInverted = colorNeutralForegroundStaticInverted;
        this.colorNeutralForegroundInverted = colorNeutralForegroundInverted;
        this.colorNeutralForegroundInvertedHover = colorNeutralForegroundInvertedHover;
        this.colorNeutralForegroundInvertedPressed = colorNeutralForegroundInvertedPressed;
        this.colorNeutralForegroundInvertedSelected = colorNeutralForegroundInvertedSelected;
        this.colorNeutralForegroundInverted2 = colorNeutralForegroundInverted2;
        this.colorNeutralForegroundOnBrand = colorNeutralForegroundOnBrand;
        this.colorNeutralForegroundInvertedLink = colorNeutralForegroundInvertedLink;
        this.colorNeutralForegroundInvertedLinkHover = colorNeutralForegroundInvertedLinkHover;
        this.colorNeutralForegroundInvertedLinkPressed = colorNeutralForegroundInvertedLinkPressed;
        this.colorNeutralForegroundInvertedLinkSelected = colorNeutralForegroundInvertedLinkSelected;
        this.colorBrandForegroundInverted = colorBrandForegroundInverted;
        this.colorBrandForegroundInvertedHover = colorBrandForegroundInvertedHover;
        this.colorBrandForegroundInvertedPressed = colorBrandForegroundInvertedPressed;
        this.colorBrandForegroundOnLight = colorBrandForegroundOnLight;
        this.colorBrandForegroundOnLightHover = colorBrandForegroundOnLightHover;
        this.colorBrandForegroundOnLightPressed = colorBrandForegroundOnLightPressed;
        this.colorBrandForegroundOnLightSelected = colorBrandForegroundOnLightSelected;
        this.colorNeutralBackground1 = colorNeutralBackground1;
        this.colorNeutralBackground1Hover = colorNeutralBackground1Hover;
        this.colorNeutralBackground1Pressed = colorNeutralBackground1Pressed;
        this.colorNeutralBackground1Selected = colorNeutralBackground1Selected;
        this.colorNeutralBackground2 = colorNeutralBackground2;
        this.colorNeutralBackground2Hover = colorNeutralBackground2Hover;
        this.colorNeutralBackground2Pressed = colorNeutralBackground2Pressed;
        this.colorNeutralBackground2Selected = colorNeutralBackground2Selected;
        this.colorNeutralBackground3 = colorNeutralBackground3;
        this.colorNeutralBackground3Hover = colorNeutralBackground3Hover;
        this.colorNeutralBackground3Pressed = colorNeutralBackground3Pressed;
        this.colorNeutralBackground3Selected = colorNeutralBackground3Selected;
        this.colorNeutralBackground4 = colorNeutralBackground4;
        this.colorNeutralBackground4Hover = colorNeutralBackground4Hover;
        this.colorNeutralBackground4Pressed = colorNeutralBackground4Pressed;
        this.colorNeutralBackground4Selected = colorNeutralBackground4Selected;
        this.colorNeutralBackground5 = colorNeutralBackground5;
        this.colorNeutralBackground5Hover = colorNeutralBackground5Hover;
        this.colorNeutralBackground5Pressed = colorNeutralBackground5Pressed;
        this.colorNeutralBackground5Selected = colorNeutralBackground5Selected;
        this.colorNeutralBackground6 = colorNeutralBackground6;
        this.colorNeutralBackgroundInverted = colorNeutralBackgroundInverted;
        this.colorNeutralBackgroundStatic = colorNeutralBackgroundStatic;
        this.colorNeutralBackgroundAlpha = colorNeutralBackgroundAlpha;
        this.colorNeutralBackgroundAlpha2 = colorNeutralBackgroundAlpha2;
        this.colorSubtleBackground = colorSubtleBackground;
        this.colorSubtleBackgroundHover = colorSubtleBackgroundHover;
        this.colorSubtleBackgroundPressed = colorSubtleBackgroundPressed;
        this.colorSubtleBackgroundSelected = colorSubtleBackgroundSelected;
        this.colorSubtleBackgroundLightAlphaHover = colorSubtleBackgroundLightAlphaHover;
        this.colorSubtleBackgroundLightAlphaPressed = colorSubtleBackgroundLightAlphaPressed;
        this.colorSubtleBackgroundLightAlphaSelected = colorSubtleBackgroundLightAlphaSelected;
        this.colorSubtleBackgroundInverted = colorSubtleBackgroundInverted;
        this.colorSubtleBackgroundInvertedHover = colorSubtleBackgroundInvertedHover;
        this.colorSubtleBackgroundInvertedPressed = colorSubtleBackgroundInvertedPressed;
        this.colorSubtleBackgroundInvertedSelected = colorSubtleBackgroundInvertedSelected;
        this.colorTransparentBackground = colorTransparentBackground;
        this.colorTransparentBackgroundHover = colorTransparentBackgroundHover;
        this.colorTransparentBackgroundPressed = colorTransparentBackgroundPressed;
        this.colorTransparentBackgroundSelected = colorTransparentBackgroundSelected;
        this.colorNeutralBackgroundDisabled = colorNeutralBackgroundDisabled;
        this.colorNeutralBackgroundInvertedDisabled = colorNeutralBackgroundInvertedDisabled;
        this.colorNeutralStencil1 = colorNeutralStencil1;
        this.colorNeutralStencil2 = colorNeutralStencil2;
        this.colorNeutralStencil1Alpha = colorNeutralStencil1Alpha;
        this.colorNeutralStencil2Alpha = colorNeutralStencil2Alpha;
        this.colorBackgroundOverlay = colorBackgroundOverlay;
        this.colorScrollbarOverlay = colorScrollbarOverlay;
        this.colorBrandBackground = colorBrandBackground;
        this.colorBrandBackgroundHover = colorBrandBackgroundHover;
        this.colorBrandBackgroundPressed = colorBrandBackgroundPressed;
        this.colorBrandBackgroundSelected = colorBrandBackgroundSelected;
        this.colorCompoundBrandBackground = colorCompoundBrandBackground;
        this.colorCompoundBrandBackgroundHover = colorCompoundBrandBackgroundHover;
        this.colorCompoundBrandBackgroundPressed = colorCompoundBrandBackgroundPressed;
        this.colorBrandBackgroundStatic = colorBrandBackgroundStatic;
        this.colorBrandBackground2 = colorBrandBackground2;
        this.colorBrandBackground2Hover = colorBrandBackground2Hover;
        this.colorBrandBackground2Pressed = colorBrandBackground2Pressed;
        this.colorBrandBackground3Static = colorBrandBackground3Static;
        this.colorBrandBackground4Static = colorBrandBackground4Static;
        this.colorBrandBackgroundInverted = colorBrandBackgroundInverted;
        this.colorBrandBackgroundInvertedHover = colorBrandBackgroundInvertedHover;
        this.colorBrandBackgroundInvertedPressed = colorBrandBackgroundInvertedPressed;
        this.colorBrandBackgroundInvertedSelected = colorBrandBackgroundInvertedSelected;
        this.colorNeutralCardBackground = colorNeutralCardBackground;
        this.colorNeutralCardBackgroundHover = colorNeutralCardBackgroundHover;
        this.colorNeutralCardBackgroundPressed = colorNeutralCardBackgroundPressed;
        this.colorNeutralCardBackgroundSelected = colorNeutralCardBackgroundSelected;
        this.colorNeutralCardBackgroundDisabled = colorNeutralCardBackgroundDisabled;
        this.colorNeutralStrokeAccessible = colorNeutralStrokeAccessible;
        this.colorNeutralStrokeAccessibleHover = colorNeutralStrokeAccessibleHover;
        this.colorNeutralStrokeAccessiblePressed = colorNeutralStrokeAccessiblePressed;
        this.colorNeutralStrokeAccessibleSelected = colorNeutralStrokeAccessibleSelected;
        this.colorNeutralStroke1 = colorNeutralStroke1;
        this.colorNeutralStroke1Hover = colorNeutralStroke1Hover;
        this.colorNeutralStroke1Pressed = colorNeutralStroke1Pressed;
        this.colorNeutralStroke1Selected = colorNeutralStroke1Selected;
        this.colorNeutralStroke2 = colorNeutralStroke2;
        this.colorNeutralStroke3 = colorNeutralStroke3;
        this.colorNeutralStrokeSubtle = colorNeutralStrokeSubtle;
        this.colorNeutralStrokeOnBrand = colorNeutralStrokeOnBrand;
        this.colorNeutralStrokeOnBrand2 = colorNeutralStrokeOnBrand2;
        this.colorNeutralStrokeOnBrand2Hover = colorNeutralStrokeOnBrand2Hover;
        this.colorNeutralStrokeOnBrand2Pressed = colorNeutralStrokeOnBrand2Pressed;
        this.colorNeutralStrokeOnBrand2Selected = colorNeutralStrokeOnBrand2Selected;
        this.colorBrandStroke1 = colorBrandStroke1;
        this.colorBrandStroke2 = colorBrandStroke2;
        this.colorBrandStroke2Hover = colorBrandStroke2Hover;
        this.colorBrandStroke2Pressed = colorBrandStroke2Pressed;
        this.colorBrandStroke2Contrast = colorBrandStroke2Contrast;
        this.colorCompoundBrandStroke = colorCompoundBrandStroke;
        this.colorCompoundBrandStrokeHover = colorCompoundBrandStrokeHover;
        this.colorCompoundBrandStrokePressed = colorCompoundBrandStrokePressed;
        this.colorNeutralStrokeDisabled = colorNeutralStrokeDisabled;
        this.colorNeutralStrokeInvertedDisabled = colorNeutralStrokeInvertedDisabled;
        this.colorTransparentStroke = colorTransparentStroke;
        this.colorTransparentStrokeInteractive = colorTransparentStrokeInteractive;
        this.colorTransparentStrokeDisabled = colorTransparentStrokeDisabled;
        this.colorNeutralStrokeAlpha = colorNeutralStrokeAlpha;
        this.colorNeutralStrokeAlpha2 = colorNeutralStrokeAlpha2;
        this.colorStrokeFocus1 = colorStrokeFocus1;
        this.colorStrokeFocus2 = colorStrokeFocus2;
        this.colorNeutralShadowAmbient = colorNeutralShadowAmbient;
        this.colorNeutralShadowKey = colorNeutralShadowKey;
        this.colorNeutralShadowAmbientLighter = colorNeutralShadowAmbientLighter;
        this.colorNeutralShadowKeyLighter = colorNeutralShadowKeyLighter;
        this.colorNeutralShadowAmbientDarker = colorNeutralShadowAmbientDarker;
        this.colorNeutralShadowKeyDarker = colorNeutralShadowKeyDarker;
        this.colorBrandShadowAmbient = colorBrandShadowAmbient;
        this.colorBrandShadowKey = colorBrandShadowKey;
        this.colorPaletteRedBackground1 = colorPaletteRedBackground1;
        this.colorPaletteRedBackground2 = colorPaletteRedBackground2;
        this.colorPaletteRedBackground3 = colorPaletteRedBackground3;
        this.colorPaletteRedForeground1 = colorPaletteRedForeground1;
        this.colorPaletteRedForeground2 = colorPaletteRedForeground2;
        this.colorPaletteRedForeground3 = colorPaletteRedForeground3;
        this.colorPaletteRedBorderActive = colorPaletteRedBorderActive;
        this.colorPaletteRedBorder1 = colorPaletteRedBorder1;
        this.colorPaletteRedBorder2 = colorPaletteRedBorder2;
        this.colorPaletteGreenBackground1 = colorPaletteGreenBackground1;
        this.colorPaletteGreenBackground2 = colorPaletteGreenBackground2;
        this.colorPaletteGreenBackground3 = colorPaletteGreenBackground3;
        this.colorPaletteGreenForeground1 = colorPaletteGreenForeground1;
        this.colorPaletteGreenForeground2 = colorPaletteGreenForeground2;
        this.colorPaletteGreenForeground3 = colorPaletteGreenForeground3;
        this.colorPaletteGreenBorderActive = colorPaletteGreenBorderActive;
        this.colorPaletteGreenBorder1 = colorPaletteGreenBorder1;
        this.colorPaletteGreenBorder2 = colorPaletteGreenBorder2;
        this.colorPaletteDarkOrangeBackground1 = colorPaletteDarkOrangeBackground1;
        this.colorPaletteDarkOrangeBackground2 = colorPaletteDarkOrangeBackground2;
        this.colorPaletteDarkOrangeBackground3 = colorPaletteDarkOrangeBackground3;
        this.colorPaletteDarkOrangeForeground1 = colorPaletteDarkOrangeForeground1;
        this.colorPaletteDarkOrangeForeground2 = colorPaletteDarkOrangeForeground2;
        this.colorPaletteDarkOrangeForeground3 = colorPaletteDarkOrangeForeground3;
        this.colorPaletteDarkOrangeBorderActive = colorPaletteDarkOrangeBorderActive;
        this.colorPaletteDarkOrangeBorder1 = colorPaletteDarkOrangeBorder1;
        this.colorPaletteDarkOrangeBorder2 = colorPaletteDarkOrangeBorder2;
        this.colorPaletteYellowBackground1 = colorPaletteYellowBackground1;
        this.colorPaletteYellowBackground2 = colorPaletteYellowBackground2;
        this.colorPaletteYellowBackground3 = colorPaletteYellowBackground3;
        this.colorPaletteYellowForeground1 = colorPaletteYellowForeground1;
        this.colorPaletteYellowForeground2 = colorPaletteYellowForeground2;
        this.colorPaletteYellowForeground3 = colorPaletteYellowForeground3;
        this.colorPaletteYellowBorderActive = colorPaletteYellowBorderActive;
        this.colorPaletteYellowBorder1 = colorPaletteYellowBorder1;
        this.colorPaletteYellowBorder2 = colorPaletteYellowBorder2;
        this.colorPaletteBerryBackground1 = colorPaletteBerryBackground1;
        this.colorPaletteBerryBackground2 = colorPaletteBerryBackground2;
        this.colorPaletteBerryBackground3 = colorPaletteBerryBackground3;
        this.colorPaletteBerryForeground1 = colorPaletteBerryForeground1;
        this.colorPaletteBerryForeground2 = colorPaletteBerryForeground2;
        this.colorPaletteBerryForeground3 = colorPaletteBerryForeground3;
        this.colorPaletteBerryBorderActive = colorPaletteBerryBorderActive;
        this.colorPaletteBerryBorder1 = colorPaletteBerryBorder1;
        this.colorPaletteBerryBorder2 = colorPaletteBerryBorder2;
        this.colorPaletteLightGreenBackground1 = colorPaletteLightGreenBackground1;
        this.colorPaletteLightGreenBackground2 = colorPaletteLightGreenBackground2;
        this.colorPaletteLightGreenBackground3 = colorPaletteLightGreenBackground3;
        this.colorPaletteLightGreenForeground1 = colorPaletteLightGreenForeground1;
        this.colorPaletteLightGreenForeground2 = colorPaletteLightGreenForeground2;
        this.colorPaletteLightGreenForeground3 = colorPaletteLightGreenForeground3;
        this.colorPaletteLightGreenBorderActive = colorPaletteLightGreenBorderActive;
        this.colorPaletteLightGreenBorder1 = colorPaletteLightGreenBorder1;
        this.colorPaletteLightGreenBorder2 = colorPaletteLightGreenBorder2;
        this.colorPaletteMarigoldBackground1 = colorPaletteMarigoldBackground1;
        this.colorPaletteMarigoldBackground2 = colorPaletteMarigoldBackground2;
        this.colorPaletteMarigoldBackground3 = colorPaletteMarigoldBackground3;
        this.colorPaletteMarigoldForeground1 = colorPaletteMarigoldForeground1;
        this.colorPaletteMarigoldForeground2 = colorPaletteMarigoldForeground2;
        this.colorPaletteMarigoldForeground3 = colorPaletteMarigoldForeground3;
        this.colorPaletteMarigoldBorderActive = colorPaletteMarigoldBorderActive;
        this.colorPaletteMarigoldBorder1 = colorPaletteMarigoldBorder1;
        this.colorPaletteMarigoldBorder2 = colorPaletteMarigoldBorder2;
        this.colorPaletteRedForegroundInverted = colorPaletteRedForegroundInverted;
        this.colorPaletteGreenForegroundInverted = colorPaletteGreenForegroundInverted;
        this.colorPaletteYellowForegroundInverted = colorPaletteYellowForegroundInverted;
        this.colorPaletteDarkRedBackground2 = colorPaletteDarkRedBackground2;
        this.colorPaletteDarkRedForeground2 = colorPaletteDarkRedForeground2;
        this.colorPaletteDarkRedBorderActive = colorPaletteDarkRedBorderActive;
        this.colorPaletteCranberryBackground2 = colorPaletteCranberryBackground2;
        this.colorPaletteCranberryForeground2 = colorPaletteCranberryForeground2;
        this.colorPaletteCranberryBorderActive = colorPaletteCranberryBorderActive;
        this.colorPalettePumpkinBackground2 = colorPalettePumpkinBackground2;
        this.colorPalettePumpkinForeground2 = colorPalettePumpkinForeground2;
        this.colorPalettePumpkinBorderActive = colorPalettePumpkinBorderActive;
        this.colorPalettePeachBackground2 = colorPalettePeachBackground2;
        this.colorPalettePeachForeground2 = colorPalettePeachForeground2;
        this.colorPalettePeachBorderActive = colorPalettePeachBorderActive;
        this.colorPaletteGoldBackground2 = colorPaletteGoldBackground2;
        this.colorPaletteGoldForeground2 = colorPaletteGoldForeground2;
        this.colorPaletteGoldBorderActive = colorPaletteGoldBorderActive;
        this.colorPaletteBrassBackground2 = colorPaletteBrassBackground2;
        this.colorPaletteBrassForeground2 = colorPaletteBrassForeground2;
        this.colorPaletteBrassBorderActive = colorPaletteBrassBorderActive;
        this.colorPaletteBrownBackground2 = colorPaletteBrownBackground2;
        this.colorPaletteBrownForeground2 = colorPaletteBrownForeground2;
        this.colorPaletteBrownBorderActive = colorPaletteBrownBorderActive;
        this.colorPaletteForestBackground2 = colorPaletteForestBackground2;
        this.colorPaletteForestForeground2 = colorPaletteForestForeground2;
        this.colorPaletteForestBorderActive = colorPaletteForestBorderActive;
        this.colorPaletteSeafoamBackground2 = colorPaletteSeafoamBackground2;
        this.colorPaletteSeafoamForeground2 = colorPaletteSeafoamForeground2;
        this.colorPaletteSeafoamBorderActive = colorPaletteSeafoamBorderActive;
        this.colorPaletteDarkGreenBackground2 = colorPaletteDarkGreenBackground2;
        this.colorPaletteDarkGreenForeground2 = colorPaletteDarkGreenForeground2;
        this.colorPaletteDarkGreenBorderActive = colorPaletteDarkGreenBorderActive;
        this.colorPaletteLightTealBackground2 = colorPaletteLightTealBackground2;
        this.colorPaletteLightTealForeground2 = colorPaletteLightTealForeground2;
        this.colorPaletteLightTealBorderActive = colorPaletteLightTealBorderActive;
        this.colorPaletteTealBackground2 = colorPaletteTealBackground2;
        this.colorPaletteTealForeground2 = colorPaletteTealForeground2;
        this.colorPaletteTealBorderActive = colorPaletteTealBorderActive;
        this.colorPaletteSteelBackground2 = colorPaletteSteelBackground2;
        this.colorPaletteSteelForeground2 = colorPaletteSteelForeground2;
        this.colorPaletteSteelBorderActive = colorPaletteSteelBorderActive;
        this.colorPaletteBlueBackground2 = colorPaletteBlueBackground2;
        this.colorPaletteBlueForeground2 = colorPaletteBlueForeground2;
        this.colorPaletteBlueBorderActive = colorPaletteBlueBorderActive;
        this.colorPaletteRoyalBlueBackground2 = colorPaletteRoyalBlueBackground2;
        this.colorPaletteRoyalBlueForeground2 = colorPaletteRoyalBlueForeground2;
        this.colorPaletteRoyalBlueBorderActive = colorPaletteRoyalBlueBorderActive;
        this.colorPaletteCornflowerBackground2 = colorPaletteCornflowerBackground2;
        this.colorPaletteCornflowerForeground2 = colorPaletteCornflowerForeground2;
        this.colorPaletteCornflowerBorderActive = colorPaletteCornflowerBorderActive;
        this.colorPaletteNavyBackground2 = colorPaletteNavyBackground2;
        this.colorPaletteNavyForeground2 = colorPaletteNavyForeground2;
        this.colorPaletteNavyBorderActive = colorPaletteNavyBorderActive;
        this.colorPaletteLavenderBackground2 = colorPaletteLavenderBackground2;
        this.colorPaletteLavenderForeground2 = colorPaletteLavenderForeground2;
        this.colorPaletteLavenderBorderActive = colorPaletteLavenderBorderActive;
        this.colorPalettePurpleBackground2 = colorPalettePurpleBackground2;
        this.colorPalettePurpleForeground2 = colorPalettePurpleForeground2;
        this.colorPalettePurpleBorderActive = colorPalettePurpleBorderActive;
        this.colorPaletteGrapeBackground2 = colorPaletteGrapeBackground2;
        this.colorPaletteGrapeForeground2 = colorPaletteGrapeForeground2;
        this.colorPaletteGrapeBorderActive = colorPaletteGrapeBorderActive;
        this.colorPaletteLilacBackground2 = colorPaletteLilacBackground2;
        this.colorPaletteLilacForeground2 = colorPaletteLilacForeground2;
        this.colorPaletteLilacBorderActive = colorPaletteLilacBorderActive;
        this.colorPalettePinkBackground2 = colorPalettePinkBackground2;
        this.colorPalettePinkForeground2 = colorPalettePinkForeground2;
        this.colorPalettePinkBorderActive = colorPalettePinkBorderActive;
        this.colorPaletteMagentaBackground2 = colorPaletteMagentaBackground2;
        this.colorPaletteMagentaForeground2 = colorPaletteMagentaForeground2;
        this.colorPaletteMagentaBorderActive = colorPaletteMagentaBorderActive;
        this.colorPalettePlumBackground2 = colorPalettePlumBackground2;
        this.colorPalettePlumForeground2 = colorPalettePlumForeground2;
        this.colorPalettePlumBorderActive = colorPalettePlumBorderActive;
        this.colorPaletteBeigeBackground2 = colorPaletteBeigeBackground2;
        this.colorPaletteBeigeForeground2 = colorPaletteBeigeForeground2;
        this.colorPaletteBeigeBorderActive = colorPaletteBeigeBorderActive;
        this.colorPaletteMinkBackground2 = colorPaletteMinkBackground2;
        this.colorPaletteMinkForeground2 = colorPaletteMinkForeground2;
        this.colorPaletteMinkBorderActive = colorPaletteMinkBorderActive;
        this.colorPalettePlatinumBackground2 = colorPalettePlatinumBackground2;
        this.colorPalettePlatinumForeground2 = colorPalettePlatinumForeground2;
        this.colorPalettePlatinumBorderActive = colorPalettePlatinumBorderActive;
        this.colorPaletteAnchorBackground2 = colorPaletteAnchorBackground2;
        this.colorPaletteAnchorForeground2 = colorPaletteAnchorForeground2;
        this.colorPaletteAnchorBorderActive = colorPaletteAnchorBorderActive;
        this.colorStatusSuccessBackground1 = colorStatusSuccessBackground1;
        this.colorStatusSuccessBackground2 = colorStatusSuccessBackground2;
        this.colorStatusSuccessBackground3 = colorStatusSuccessBackground3;
        this.colorStatusSuccessForeground1 = colorStatusSuccessForeground1;
        this.colorStatusSuccessForeground2 = colorStatusSuccessForeground2;
        this.colorStatusSuccessForeground3 = colorStatusSuccessForeground3;
        this.colorStatusSuccessBorderActive = colorStatusSuccessBorderActive;
        this.colorStatusSuccessForegroundInverted = colorStatusSuccessForegroundInverted;
        this.colorStatusSuccessBorder1 = colorStatusSuccessBorder1;
        this.colorStatusSuccessBorder2 = colorStatusSuccessBorder2;
        this.colorStatusWarningBackground1 = colorStatusWarningBackground1;
        this.colorStatusWarningBackground2 = colorStatusWarningBackground2;
        this.colorStatusWarningBackground3 = colorStatusWarningBackground3;
        this.colorStatusWarningForeground1 = colorStatusWarningForeground1;
        this.colorStatusWarningForeground2 = colorStatusWarningForeground2;
        this.colorStatusWarningForeground3 = colorStatusWarningForeground3;
        this.colorStatusWarningBorderActive = colorStatusWarningBorderActive;
        this.colorStatusWarningForegroundInverted = colorStatusWarningForegroundInverted;
        this.colorStatusWarningBorder1 = colorStatusWarningBorder1;
        this.colorStatusWarningBorder2 = colorStatusWarningBorder2;
        this.colorStatusDangerBackground1 = colorStatusDangerBackground1;
        this.colorStatusDangerBackground2 = colorStatusDangerBackground2;
        this.colorStatusDangerBackground3 = colorStatusDangerBackground3;
        this.colorStatusDangerForeground1 = colorStatusDangerForeground1;
        this.colorStatusDangerForeground2 = colorStatusDangerForeground2;
        this.colorStatusDangerForeground3 = colorStatusDangerForeground3;
        this.colorStatusDangerBorderActive = colorStatusDangerBorderActive;
        this.colorStatusDangerForegroundInverted = colorStatusDangerForegroundInverted;
        this.colorStatusDangerBorder1 = colorStatusDangerBorder1;
        this.colorStatusDangerBorder2 = colorStatusDangerBorder2;
        this.shadow2 = shadow2;
        this.shadow4 = shadow4;
        this.shadow8 = shadow8;
        this.shadow16 = shadow16;
        this.shadow28 = shadow28;
        this.shadow64 = shadow64;
        this.shadow2Brand = shadow2Brand;
        this.shadow4Brand = shadow4Brand;
        this.shadow8Brand = shadow8Brand;
        this.shadow16Brand = shadow16Brand;
        this.shadow28Brand = shadow28Brand;
        this.shadow64Brand = shadow64Brand;
        this.zIndexBackground = zIndexBackground;
        this.zIndexContent = zIndexContent;
        this.zIndexOverlay = zIndexOverlay;
        this.zIndexPopup = zIndexPopup;
        this.zIndexMessages = zIndexMessages;
        this.zIndexFloating = zIndexFloating;
        this.zIndexPriority = zIndexPriority;
        this.zIndexDebug = zIndexDebug;
    }
}

export function Tokens_$reflection() {
    return record_type("FS.FluentUI.Tokens", [], Tokens, () => [["borderRadiusNone", string_type], ["borderRadiusSmall", string_type], ["borderRadiusMedium", string_type], ["borderRadiusLarge", string_type], ["borderRadiusXLarge", string_type], ["borderRadiusCircular", string_type], ["fontSizeBase100", string_type], ["fontSizeBase200", string_type], ["fontSizeBase300", string_type], ["fontSizeBase400", string_type], ["fontSizeBase500", string_type], ["fontSizeBase600", string_type], ["fontSizeHero700", string_type], ["fontSizeHero800", string_type], ["fontSizeHero900", string_type], ["fontSizeHero1000", string_type], ["lineHeightBase100", string_type], ["lineHeightBase200", string_type], ["lineHeightBase300", string_type], ["lineHeightBase400", string_type], ["lineHeightBase500", string_type], ["lineHeightBase600", string_type], ["lineHeightHero700", string_type], ["lineHeightHero800", string_type], ["lineHeightHero900", string_type], ["lineHeightHero1000", string_type], ["fontFamilyBase", string_type], ["fontFamilyMonospace", string_type], ["fontFamilyNumeric", string_type], ["fontWeightRegular", int32_type], ["fontWeightMedium", int32_type], ["fontWeightSemibold", int32_type], ["fontWeightBold", int32_type], ["strokeWidthThin", string_type], ["strokeWidthThick", string_type], ["strokeWidthThicker", string_type], ["strokeWidthThickest", string_type], ["spacingHorizontalNone", string_type], ["spacingHorizontalXXS", string_type], ["spacingHorizontalXS", string_type], ["spacingHorizontalSNudge", string_type], ["spacingHorizontalS", string_type], ["spacingHorizontalMNudge", string_type], ["spacingHorizontalM", string_type], ["spacingHorizontalL", string_type], ["spacingHorizontalXL", string_type], ["spacingHorizontalXXL", string_type], ["spacingHorizontalXXXL", string_type], ["spacingVerticalNone", string_type], ["spacingVerticalXXS", string_type], ["spacingVerticalXS", string_type], ["spacingVerticalSNudge", string_type], ["spacingVerticalS", string_type], ["spacingVerticalMNudge", string_type], ["spacingVerticalM", string_type], ["spacingVerticalL", string_type], ["spacingVerticalXL", string_type], ["spacingVerticalXXL", string_type], ["spacingVerticalXXXL", string_type], ["durationUltraFast", string_type], ["durationFaster", string_type], ["durationFast", string_type], ["durationNormal", string_type], ["durationGentle", string_type], ["durationSlow", string_type], ["durationSlower", string_type], ["durationUltraSlow", string_type], ["curveAccelerateMax", string_type], ["curveAccelerateMid", string_type], ["curveAccelerateMin", string_type], ["curveDecelerateMax", string_type], ["curveDecelerateMid", string_type], ["curveDecelerateMin", string_type], ["curveEasyEaseMax", string_type], ["curveEasyEase", string_type], ["curveLinear", string_type], ["colorNeutralForeground1", string_type], ["colorNeutralForeground1Hover", string_type], ["colorNeutralForeground1Pressed", string_type], ["colorNeutralForeground1Selected", string_type], ["colorNeutralForeground2", string_type], ["colorNeutralForeground2Hover", string_type], ["colorNeutralForeground2Pressed", string_type], ["colorNeutralForeground2Selected", string_type], ["colorNeutralForeground2BrandHover", string_type], ["colorNeutralForeground2BrandPressed", string_type], ["colorNeutralForeground2BrandSelected", string_type], ["colorNeutralForeground3", string_type], ["colorNeutralForeground3Hover", string_type], ["colorNeutralForeground3Pressed", string_type], ["colorNeutralForeground3Selected", string_type], ["colorNeutralForeground3BrandHover", string_type], ["colorNeutralForeground3BrandPressed", string_type], ["colorNeutralForeground3BrandSelected", string_type], ["colorNeutralForeground4", string_type], ["colorNeutralForegroundDisabled", string_type], ["colorNeutralForegroundInvertedDisabled", string_type], ["colorBrandForegroundLink", string_type], ["colorBrandForegroundLinkHover", string_type], ["colorBrandForegroundLinkPressed", string_type], ["colorBrandForegroundLinkSelected", string_type], ["colorNeutralForeground2Link", string_type], ["colorNeutralForeground2LinkHover", string_type], ["colorNeutralForeground2LinkPressed", string_type], ["colorNeutralForeground2LinkSelected", string_type], ["colorCompoundBrandForeground1", string_type], ["colorCompoundBrandForeground1Hover", string_type], ["colorCompoundBrandForeground1Pressed", string_type], ["colorBrandForeground1", string_type], ["colorBrandForeground2", string_type], ["colorBrandForeground2Hover", string_type], ["colorBrandForeground2Pressed", string_type], ["colorNeutralForeground1Static", string_type], ["colorNeutralForegroundStaticInverted", string_type], ["colorNeutralForegroundInverted", string_type], ["colorNeutralForegroundInvertedHover", string_type], ["colorNeutralForegroundInvertedPressed", string_type], ["colorNeutralForegroundInvertedSelected", string_type], ["colorNeutralForegroundInverted2", string_type], ["colorNeutralForegroundOnBrand", string_type], ["colorNeutralForegroundInvertedLink", string_type], ["colorNeutralForegroundInvertedLinkHover", string_type], ["colorNeutralForegroundInvertedLinkPressed", string_type], ["colorNeutralForegroundInvertedLinkSelected", string_type], ["colorBrandForegroundInverted", string_type], ["colorBrandForegroundInvertedHover", string_type], ["colorBrandForegroundInvertedPressed", string_type], ["colorBrandForegroundOnLight", string_type], ["colorBrandForegroundOnLightHover", string_type], ["colorBrandForegroundOnLightPressed", string_type], ["colorBrandForegroundOnLightSelected", string_type], ["colorNeutralBackground1", string_type], ["colorNeutralBackground1Hover", string_type], ["colorNeutralBackground1Pressed", string_type], ["colorNeutralBackground1Selected", string_type], ["colorNeutralBackground2", string_type], ["colorNeutralBackground2Hover", string_type], ["colorNeutralBackground2Pressed", string_type], ["colorNeutralBackground2Selected", string_type], ["colorNeutralBackground3", string_type], ["colorNeutralBackground3Hover", string_type], ["colorNeutralBackground3Pressed", string_type], ["colorNeutralBackground3Selected", string_type], ["colorNeutralBackground4", string_type], ["colorNeutralBackground4Hover", string_type], ["colorNeutralBackground4Pressed", string_type], ["colorNeutralBackground4Selected", string_type], ["colorNeutralBackground5", string_type], ["colorNeutralBackground5Hover", string_type], ["colorNeutralBackground5Pressed", string_type], ["colorNeutralBackground5Selected", string_type], ["colorNeutralBackground6", string_type], ["colorNeutralBackgroundInverted", string_type], ["colorNeutralBackgroundStatic", string_type], ["colorNeutralBackgroundAlpha", string_type], ["colorNeutralBackgroundAlpha2", string_type], ["colorSubtleBackground", string_type], ["colorSubtleBackgroundHover", string_type], ["colorSubtleBackgroundPressed", string_type], ["colorSubtleBackgroundSelected", string_type], ["colorSubtleBackgroundLightAlphaHover", string_type], ["colorSubtleBackgroundLightAlphaPressed", string_type], ["colorSubtleBackgroundLightAlphaSelected", string_type], ["colorSubtleBackgroundInverted", string_type], ["colorSubtleBackgroundInvertedHover", string_type], ["colorSubtleBackgroundInvertedPressed", string_type], ["colorSubtleBackgroundInvertedSelected", string_type], ["colorTransparentBackground", string_type], ["colorTransparentBackgroundHover", string_type], ["colorTransparentBackgroundPressed", string_type], ["colorTransparentBackgroundSelected", string_type], ["colorNeutralBackgroundDisabled", string_type], ["colorNeutralBackgroundInvertedDisabled", string_type], ["colorNeutralStencil1", string_type], ["colorNeutralStencil2", string_type], ["colorNeutralStencil1Alpha", string_type], ["colorNeutralStencil2Alpha", string_type], ["colorBackgroundOverlay", string_type], ["colorScrollbarOverlay", string_type], ["colorBrandBackground", string_type], ["colorBrandBackgroundHover", string_type], ["colorBrandBackgroundPressed", string_type], ["colorBrandBackgroundSelected", string_type], ["colorCompoundBrandBackground", string_type], ["colorCompoundBrandBackgroundHover", string_type], ["colorCompoundBrandBackgroundPressed", string_type], ["colorBrandBackgroundStatic", string_type], ["colorBrandBackground2", string_type], ["colorBrandBackground2Hover", string_type], ["colorBrandBackground2Pressed", string_type], ["colorBrandBackground3Static", string_type], ["colorBrandBackground4Static", string_type], ["colorBrandBackgroundInverted", string_type], ["colorBrandBackgroundInvertedHover", string_type], ["colorBrandBackgroundInvertedPressed", string_type], ["colorBrandBackgroundInvertedSelected", string_type], ["colorNeutralCardBackground", string_type], ["colorNeutralCardBackgroundHover", string_type], ["colorNeutralCardBackgroundPressed", string_type], ["colorNeutralCardBackgroundSelected", string_type], ["colorNeutralCardBackgroundDisabled", string_type], ["colorNeutralStrokeAccessible", string_type], ["colorNeutralStrokeAccessibleHover", string_type], ["colorNeutralStrokeAccessiblePressed", string_type], ["colorNeutralStrokeAccessibleSelected", string_type], ["colorNeutralStroke1", string_type], ["colorNeutralStroke1Hover", string_type], ["colorNeutralStroke1Pressed", string_type], ["colorNeutralStroke1Selected", string_type], ["colorNeutralStroke2", string_type], ["colorNeutralStroke3", string_type], ["colorNeutralStrokeSubtle", string_type], ["colorNeutralStrokeOnBrand", string_type], ["colorNeutralStrokeOnBrand2", string_type], ["colorNeutralStrokeOnBrand2Hover", string_type], ["colorNeutralStrokeOnBrand2Pressed", string_type], ["colorNeutralStrokeOnBrand2Selected", string_type], ["colorBrandStroke1", string_type], ["colorBrandStroke2", string_type], ["colorBrandStroke2Hover", string_type], ["colorBrandStroke2Pressed", string_type], ["colorBrandStroke2Contrast", string_type], ["colorCompoundBrandStroke", string_type], ["colorCompoundBrandStrokeHover", string_type], ["colorCompoundBrandStrokePressed", string_type], ["colorNeutralStrokeDisabled", string_type], ["colorNeutralStrokeInvertedDisabled", string_type], ["colorTransparentStroke", string_type], ["colorTransparentStrokeInteractive", string_type], ["colorTransparentStrokeDisabled", string_type], ["colorNeutralStrokeAlpha", string_type], ["colorNeutralStrokeAlpha2", string_type], ["colorStrokeFocus1", string_type], ["colorStrokeFocus2", string_type], ["colorNeutralShadowAmbient", string_type], ["colorNeutralShadowKey", string_type], ["colorNeutralShadowAmbientLighter", string_type], ["colorNeutralShadowKeyLighter", string_type], ["colorNeutralShadowAmbientDarker", string_type], ["colorNeutralShadowKeyDarker", string_type], ["colorBrandShadowAmbient", string_type], ["colorBrandShadowKey", string_type], ["colorPaletteRedBackground1", string_type], ["colorPaletteRedBackground2", string_type], ["colorPaletteRedBackground3", string_type], ["colorPaletteRedForeground1", string_type], ["colorPaletteRedForeground2", string_type], ["colorPaletteRedForeground3", string_type], ["colorPaletteRedBorderActive", string_type], ["colorPaletteRedBorder1", string_type], ["colorPaletteRedBorder2", string_type], ["colorPaletteGreenBackground1", string_type], ["colorPaletteGreenBackground2", string_type], ["colorPaletteGreenBackground3", string_type], ["colorPaletteGreenForeground1", string_type], ["colorPaletteGreenForeground2", string_type], ["colorPaletteGreenForeground3", string_type], ["colorPaletteGreenBorderActive", string_type], ["colorPaletteGreenBorder1", string_type], ["colorPaletteGreenBorder2", string_type], ["colorPaletteDarkOrangeBackground1", string_type], ["colorPaletteDarkOrangeBackground2", string_type], ["colorPaletteDarkOrangeBackground3", string_type], ["colorPaletteDarkOrangeForeground1", string_type], ["colorPaletteDarkOrangeForeground2", string_type], ["colorPaletteDarkOrangeForeground3", string_type], ["colorPaletteDarkOrangeBorderActive", string_type], ["colorPaletteDarkOrangeBorder1", string_type], ["colorPaletteDarkOrangeBorder2", string_type], ["colorPaletteYellowBackground1", string_type], ["colorPaletteYellowBackground2", string_type], ["colorPaletteYellowBackground3", string_type], ["colorPaletteYellowForeground1", string_type], ["colorPaletteYellowForeground2", string_type], ["colorPaletteYellowForeground3", string_type], ["colorPaletteYellowBorderActive", string_type], ["colorPaletteYellowBorder1", string_type], ["colorPaletteYellowBorder2", string_type], ["colorPaletteBerryBackground1", string_type], ["colorPaletteBerryBackground2", string_type], ["colorPaletteBerryBackground3", string_type], ["colorPaletteBerryForeground1", string_type], ["colorPaletteBerryForeground2", string_type], ["colorPaletteBerryForeground3", string_type], ["colorPaletteBerryBorderActive", string_type], ["colorPaletteBerryBorder1", string_type], ["colorPaletteBerryBorder2", string_type], ["colorPaletteLightGreenBackground1", string_type], ["colorPaletteLightGreenBackground2", string_type], ["colorPaletteLightGreenBackground3", string_type], ["colorPaletteLightGreenForeground1", string_type], ["colorPaletteLightGreenForeground2", string_type], ["colorPaletteLightGreenForeground3", string_type], ["colorPaletteLightGreenBorderActive", string_type], ["colorPaletteLightGreenBorder1", string_type], ["colorPaletteLightGreenBorder2", string_type], ["colorPaletteMarigoldBackground1", string_type], ["colorPaletteMarigoldBackground2", string_type], ["colorPaletteMarigoldBackground3", string_type], ["colorPaletteMarigoldForeground1", string_type], ["colorPaletteMarigoldForeground2", string_type], ["colorPaletteMarigoldForeground3", string_type], ["colorPaletteMarigoldBorderActive", string_type], ["colorPaletteMarigoldBorder1", string_type], ["colorPaletteMarigoldBorder2", string_type], ["colorPaletteRedForegroundInverted", string_type], ["colorPaletteGreenForegroundInverted", string_type], ["colorPaletteYellowForegroundInverted", string_type], ["colorPaletteDarkRedBackground2", string_type], ["colorPaletteDarkRedForeground2", string_type], ["colorPaletteDarkRedBorderActive", string_type], ["colorPaletteCranberryBackground2", string_type], ["colorPaletteCranberryForeground2", string_type], ["colorPaletteCranberryBorderActive", string_type], ["colorPalettePumpkinBackground2", string_type], ["colorPalettePumpkinForeground2", string_type], ["colorPalettePumpkinBorderActive", string_type], ["colorPalettePeachBackground2", string_type], ["colorPalettePeachForeground2", string_type], ["colorPalettePeachBorderActive", string_type], ["colorPaletteGoldBackground2", string_type], ["colorPaletteGoldForeground2", string_type], ["colorPaletteGoldBorderActive", string_type], ["colorPaletteBrassBackground2", string_type], ["colorPaletteBrassForeground2", string_type], ["colorPaletteBrassBorderActive", string_type], ["colorPaletteBrownBackground2", string_type], ["colorPaletteBrownForeground2", string_type], ["colorPaletteBrownBorderActive", string_type], ["colorPaletteForestBackground2", string_type], ["colorPaletteForestForeground2", string_type], ["colorPaletteForestBorderActive", string_type], ["colorPaletteSeafoamBackground2", string_type], ["colorPaletteSeafoamForeground2", string_type], ["colorPaletteSeafoamBorderActive", string_type], ["colorPaletteDarkGreenBackground2", string_type], ["colorPaletteDarkGreenForeground2", string_type], ["colorPaletteDarkGreenBorderActive", string_type], ["colorPaletteLightTealBackground2", string_type], ["colorPaletteLightTealForeground2", string_type], ["colorPaletteLightTealBorderActive", string_type], ["colorPaletteTealBackground2", string_type], ["colorPaletteTealForeground2", string_type], ["colorPaletteTealBorderActive", string_type], ["colorPaletteSteelBackground2", string_type], ["colorPaletteSteelForeground2", string_type], ["colorPaletteSteelBorderActive", string_type], ["colorPaletteBlueBackground2", string_type], ["colorPaletteBlueForeground2", string_type], ["colorPaletteBlueBorderActive", string_type], ["colorPaletteRoyalBlueBackground2", string_type], ["colorPaletteRoyalBlueForeground2", string_type], ["colorPaletteRoyalBlueBorderActive", string_type], ["colorPaletteCornflowerBackground2", string_type], ["colorPaletteCornflowerForeground2", string_type], ["colorPaletteCornflowerBorderActive", string_type], ["colorPaletteNavyBackground2", string_type], ["colorPaletteNavyForeground2", string_type], ["colorPaletteNavyBorderActive", string_type], ["colorPaletteLavenderBackground2", string_type], ["colorPaletteLavenderForeground2", string_type], ["colorPaletteLavenderBorderActive", string_type], ["colorPalettePurpleBackground2", string_type], ["colorPalettePurpleForeground2", string_type], ["colorPalettePurpleBorderActive", string_type], ["colorPaletteGrapeBackground2", string_type], ["colorPaletteGrapeForeground2", string_type], ["colorPaletteGrapeBorderActive", string_type], ["colorPaletteLilacBackground2", string_type], ["colorPaletteLilacForeground2", string_type], ["colorPaletteLilacBorderActive", string_type], ["colorPalettePinkBackground2", string_type], ["colorPalettePinkForeground2", string_type], ["colorPalettePinkBorderActive", string_type], ["colorPaletteMagentaBackground2", string_type], ["colorPaletteMagentaForeground2", string_type], ["colorPaletteMagentaBorderActive", string_type], ["colorPalettePlumBackground2", string_type], ["colorPalettePlumForeground2", string_type], ["colorPalettePlumBorderActive", string_type], ["colorPaletteBeigeBackground2", string_type], ["colorPaletteBeigeForeground2", string_type], ["colorPaletteBeigeBorderActive", string_type], ["colorPaletteMinkBackground2", string_type], ["colorPaletteMinkForeground2", string_type], ["colorPaletteMinkBorderActive", string_type], ["colorPalettePlatinumBackground2", string_type], ["colorPalettePlatinumForeground2", string_type], ["colorPalettePlatinumBorderActive", string_type], ["colorPaletteAnchorBackground2", string_type], ["colorPaletteAnchorForeground2", string_type], ["colorPaletteAnchorBorderActive", string_type], ["colorStatusSuccessBackground1", string_type], ["colorStatusSuccessBackground2", string_type], ["colorStatusSuccessBackground3", string_type], ["colorStatusSuccessForeground1", string_type], ["colorStatusSuccessForeground2", string_type], ["colorStatusSuccessForeground3", string_type], ["colorStatusSuccessBorderActive", string_type], ["colorStatusSuccessForegroundInverted", string_type], ["colorStatusSuccessBorder1", string_type], ["colorStatusSuccessBorder2", string_type], ["colorStatusWarningBackground1", string_type], ["colorStatusWarningBackground2", string_type], ["colorStatusWarningBackground3", string_type], ["colorStatusWarningForeground1", string_type], ["colorStatusWarningForeground2", string_type], ["colorStatusWarningForeground3", string_type], ["colorStatusWarningBorderActive", string_type], ["colorStatusWarningForegroundInverted", string_type], ["colorStatusWarningBorder1", string_type], ["colorStatusWarningBorder2", string_type], ["colorStatusDangerBackground1", string_type], ["colorStatusDangerBackground2", string_type], ["colorStatusDangerBackground3", string_type], ["colorStatusDangerForeground1", string_type], ["colorStatusDangerForeground2", string_type], ["colorStatusDangerForeground3", string_type], ["colorStatusDangerBorderActive", string_type], ["colorStatusDangerForegroundInverted", string_type], ["colorStatusDangerBorder1", string_type], ["colorStatusDangerBorder2", string_type], ["shadow2", string_type], ["shadow4", string_type], ["shadow8", string_type], ["shadow16", string_type], ["shadow28", string_type], ["shadow64", string_type], ["shadow2Brand", string_type], ["shadow4Brand", string_type], ["shadow8Brand", string_type], ["shadow16Brand", string_type], ["shadow28Brand", string_type], ["shadow64Brand", string_type], ["zIndexBackground", string_type], ["zIndexContent", string_type], ["zIndexOverlay", string_type], ["zIndexPopup", string_type], ["zIndexMessages", string_type], ["zIndexFloating", string_type], ["zIndexPriority", string_type], ["zIndexDebug", string_type]]);
}

export function Tokens__get_felizFontSizeBase100(this$) {
    return 10 + "px";
}

export function Tokens__get_felizFontSizeBase200(this$) {
    return 12 + "px";
}

export function Tokens__get_felizFontSizeBase300(this$) {
    return 14 + "px";
}

export function Tokens__get_felizFontSizeBase400(this$) {
    return 16 + "px";
}

export function Tokens__get_felizFontSizeBase500(this$) {
    return 20 + "px";
}

export function Tokens__get_felizFontSizeBase600(this$) {
    return 24 + "px";
}

export function Tokens__get_felizFontSizeBase700(this$) {
    return 28 + "px";
}

export function Tokens__get_felizFontSizeBase800(this$) {
    return 32 + "px";
}

export function Tokens__get_felizFontSizeBase900(this$) {
    return 40 + "px";
}

export function Tokens__get_felizFontSizeBase1000(this$) {
    return 68 + "px";
}

export function Tokens__get_felizLineHeightBase100(this$) {
    return 14 + "px";
}

export function Tokens__get_felizLineHeightBase200(this$) {
    return 16 + "px";
}

export function Tokens__get_felizLineHeightBase300(this$) {
    return 20 + "px";
}

export function Tokens__get_felizLineHeightBase400(this$) {
    return 22 + "px";
}

export function Tokens__get_felizLineHeightBase500(this$) {
    return 28 + "px";
}

export function Tokens__get_felizLineHeightBase600(this$) {
    return 32 + "px";
}

export function Tokens__get_felizLineHeightBase700(this$) {
    return 36 + "px";
}

export function Tokens__get_felizLineHeightBase800(this$) {
    return 40 + "px";
}

export function Tokens__get_felizLineHeightBase900(this$) {
    return 52 + "px";
}

export function Tokens__get_felizLineHeightBase1000(this$) {
    return 92 + "px";
}

export function Tokens__get_felizFontWeightRegular(this$) {
    return 400;
}

export function Tokens__get_felizFontWeightMedium(this$) {
    return 500;
}

export function Tokens__get_felizFontWeightSemibold(this$) {
    return 600;
}

export function Tokens__get_felizFontWeightBold(this$) {
    return 700;
}

export class TypographyStyle extends Record {
    constructor(fontFamily, fontSize, fontWeight, lineHeight) {
        super();
        this.fontFamily = fontFamily;
        this.fontSize = fontSize;
        this.fontWeight = fontWeight;
        this.lineHeight = lineHeight;
    }
}

export function TypographyStyle_$reflection() {
    return record_type("FS.FluentUI.TypographyStyle", [], TypographyStyle, () => [["fontFamily", string_type], ["fontSize", string_type], ["fontWeight", string_type], ["lineHeight", string_type]]);
}

export function TypographyStyle__get_felizFontSize(this$) {
    const matchValue = this$.fontSize;
    switch (matchValue) {
        case "var(--fontSizeBase100)":
            return 10 + "px";
        case "var(--fontSizeBase200)":
            return 12 + "px";
        case "var(--fontSizeBase300)":
            return 14 + "px";
        case "var(--fontSizeBase400)":
            return 16 + "px";
        case "var(--fontSizeBase500)":
            return 20 + "px";
        case "var(--fontSizeBase600)":
            return 24 + "px";
        case "var(--fontSizeHero700)":
            return 28 + "px";
        case "var(--fontSizeHero800)":
            return 32 + "px";
        case "var(--fontSizeHero900)":
            return 40 + "px";
        case "var(--fontSizeHero1000)":
            return 68 + "px";
        default:
            return 1 + "em";
    }
}

export function TypographyStyle__get_felizLineHeight(this$) {
    const matchValue = this$.lineHeight;
    switch (matchValue) {
        case "var(--lineHeightBase100)":
            return 14 + "px";
        case "var(--lineHeightBase200)":
            return 16 + "px";
        case "var(--lineHeightBase300)":
            return 20 + "px";
        case "var(--lineHeightBase400)":
            return 22 + "px";
        case "var(--lineHeightBase500)":
            return 28 + "px";
        case "var(--lineHeightBase600)":
            return 32 + "px";
        case "var(--lineHeightHero700)":
            return 36 + "px";
        case "var(--lineHeightHero800)":
            return 40 + "px";
        case "var(--lineHeightHero900)":
            return 52 + "px";
        case "var(--lineHeightHero1000)":
            return 92 + "px";
        default:
            return 1 + "em";
    }
}

export function TypographyStyle__get_felizFontWeight(this$) {
    const matchValue = this$.fontWeight;
    switch (matchValue) {
        case "var(--fontWeightRegular)":
            return 400;
        case "var(--fontWeightMedium)":
            return 500;
        case "var(--fontWeightSemibold)":
            return 600;
        case "var(--fontWeightBold)":
            return 700;
        default:
            return 400;
    }
}

export class TypographyStyles extends Record {
    constructor(body1, body1Strong, body1Stronger, body2, caption1, caption1Strong, caption1Stronger, caption2, caption2Strong, subtitle1, subtitle2, subtitle2Stronger, title1, title2, title3, largeTitle, display) {
        super();
        this.body1 = body1;
        this.body1Strong = body1Strong;
        this.body1Stronger = body1Stronger;
        this.body2 = body2;
        this.caption1 = caption1;
        this.caption1Strong = caption1Strong;
        this.caption1Stronger = caption1Stronger;
        this.caption2 = caption2;
        this.caption2Strong = caption2Strong;
        this.subtitle1 = subtitle1;
        this.subtitle2 = subtitle2;
        this.subtitle2Stronger = subtitle2Stronger;
        this.title1 = title1;
        this.title2 = title2;
        this.title3 = title3;
        this.largeTitle = largeTitle;
        this.display = display;
    }
}

export function TypographyStyles_$reflection() {
    return record_type("FS.FluentUI.TypographyStyles", [], TypographyStyles, () => [["body1", TypographyStyle_$reflection()], ["body1Strong", TypographyStyle_$reflection()], ["body1Stronger", TypographyStyle_$reflection()], ["body2", TypographyStyle_$reflection()], ["caption1", TypographyStyle_$reflection()], ["caption1Strong", TypographyStyle_$reflection()], ["caption1Stronger", TypographyStyle_$reflection()], ["caption2", TypographyStyle_$reflection()], ["caption2Strong", TypographyStyle_$reflection()], ["subtitle1", TypographyStyle_$reflection()], ["subtitle2", TypographyStyle_$reflection()], ["subtitle2Stronger", TypographyStyle_$reflection()], ["title1", TypographyStyle_$reflection()], ["title2", TypographyStyle_$reflection()], ["title3", TypographyStyle_$reflection()], ["largeTitle", TypographyStyle_$reflection()], ["display", TypographyStyle_$reflection()]]);
}

export class TreeOpen extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["ExpandIconClick", "Click", "Enter", "ArrowRight", "ArrowLeft"];
    }
}

export function TreeOpen_$reflection() {
    return union_type("FS.FluentUI.TreeOpen", [], TreeOpen, () => [[], [], [], [], []]);
}

export class TreeOpenChangeData$2 extends Record {
    constructor(open, openItems, value, target, event, type) {
        super();
        this.open = open;
        this.openItems = openItems;
        this.value = value;
        this.target = target;
        this.event = event;
        this.type = type;
    }
}

export function TreeOpenChangeData$2_$reflection(gen0, gen1) {
    return record_type("FS.FluentUI.TreeOpenChangeData`2", [gen0, gen1], TreeOpenChangeData$2, () => [["open", bool_type], ["openItems", class_type("System.Collections.Generic.IEnumerable`1", [gen0])], ["value", gen0], ["target", class_type("Browser.Types.HTMLElement")], ["event", gen1], ["type", TreeOpen_$reflection()]]);
}

export class TreeItemOpenChangeData$2 extends Record {
    constructor(open, value, target, event, type) {
        super();
        this.open = open;
        this.value = value;
        this.target = target;
        this.event = event;
        this.type = type;
    }
}

export function TreeItemOpenChangeData$2_$reflection(gen0, gen1) {
    return record_type("FS.FluentUI.TreeItemOpenChangeData`2", [gen0, gen1], TreeItemOpenChangeData$2, () => [["open", bool_type], ["value", gen0], ["target", class_type("Browser.Types.HTMLElement")], ["event", gen1], ["type", TreeOpen_$reflection()]]);
}

export class TreeNavigationData_unstable$2 extends Record {
    constructor(target, value, event, type) {
        super();
        this.target = target;
        this.value = value;
        this.event = event;
        this.type = type;
    }
}

export function TreeNavigationData_unstable$2_$reflection(gen0, gen1) {
    return record_type("FS.FluentUI.TreeNavigationData_unstable`2", [gen0, gen1], TreeNavigationData_unstable$2, () => [["target", class_type("Browser.Types.HTMLElement")], ["value", gen0], ["event", gen1], ["type", TreeOpen_$reflection()]]);
}

export class TreeItemType extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["leaf", "branch"];
    }
}

export function TreeItemType_$reflection() {
    return union_type("FS.FluentUI.TreeItemType", [], TreeItemType, () => [[], []]);
}

export class HeadlessTreeItemProps$1 extends Record {
    constructor(value, itemType, parentValue, aria$002Dlevel, aria$002Dsetsize, aria$002Dposinset) {
        super();
        this.value = value;
        this.itemType = itemType;
        this.parentValue = parentValue;
        this["aria-level"] = (aria$002Dlevel | 0);
        this["aria-setsize"] = (aria$002Dsetsize | 0);
        this["aria-posinset"] = (aria$002Dposinset | 0);
    }
}

export function HeadlessTreeItemProps$1_$reflection(gen0) {
    return record_type("FS.FluentUI.HeadlessTreeItemProps`1", [gen0], HeadlessTreeItemProps$1, () => [["value", gen0], ["itemType", TreeItemType_$reflection()], ["parentValue", option_type(gen0)], ["aria-level", int32_type], ["aria-setsize", int32_type], ["aria-posinset", int32_type]]);
}

export class TreeCheckedChangeData$2 extends Record {
    constructor(value, checkedItems, target, event, type, selectionMode, checked) {
        super();
        this.value = value;
        this.checkedItems = checkedItems;
        this.target = target;
        this.event = event;
        this.type = type;
        this.selectionMode = selectionMode;
        this.checked = checked;
    }
}

export function TreeCheckedChangeData$2_$reflection(gen0, gen1) {
    return record_type("FS.FluentUI.TreeCheckedChangeData`2", [gen0, gen1], TreeCheckedChangeData$2, () => [["value", gen0], ["checkedItems", list_type(gen0)], ["target", class_type("Browser.Types.HTMLElement")], ["event", gen1], ["type", TreeOpen_$reflection()], ["selectionMode", string_type], ["checked", string_type]]);
}

export class FlatTreeProps$3 extends Record {
    constructor(openItems, onOpenChange, onNavigation, selectionMode, checkedItems, onCheckedChange, ref) {
        super();
        this.openItems = openItems;
        this.onOpenChange = onOpenChange;
        this.onNavigation = onNavigation;
        this.selectionMode = selectionMode;
        this.checkedItems = checkedItems;
        this.onCheckedChange = onCheckedChange;
        this.ref = ref;
    }
}

export function FlatTreeProps$3_$reflection(gen0, gen1, gen2) {
    return record_type("FS.FluentUI.FlatTreeProps`3", [gen0, gen1, gen2], FlatTreeProps$3, () => [["openItems", class_type("System.Collections.Generic.IEnumerable`1", [gen0])], ["onOpenChange", lambda_type(gen1, lambda_type(TreeOpenChangeData$2_$reflection(gen0, gen1), unit_type))], ["onNavigation", lambda_type(gen1, lambda_type(TreeNavigationData_unstable$2_$reflection(gen0, gen1), unit_type))], ["selectionMode", string_type], ["checkedItems", class_type("System.Collections.Generic.IEnumerable`1", [gen2])], ["onCheckedChange", lambda_type(gen1, lambda_type(TreeCheckedChangeData$2_$reflection(gen0, gen1), unit_type))], ["ref", class_type("Fable.React.IRefValue`1", [class_type("Browser.Types.HTMLDivElement")])]]);
}

export class HeadlessTreeItem$1 extends Record {
    constructor(level, index, position, childrenValues, value, parentValue, itemType, getTreeItemProps) {
        super();
        this.level = (level | 0);
        this.index = (index | 0);
        this.position = (position | 0);
        this.childrenValues = childrenValues;
        this.value = value;
        this.parentValue = parentValue;
        this.itemType = itemType;
        this.getTreeItemProps = getTreeItemProps;
    }
}

export function HeadlessTreeItem$1_$reflection(gen0) {
    return record_type("FS.FluentUI.HeadlessTreeItem`1", [gen0], HeadlessTreeItem$1, () => [["level", int32_type], ["index", int32_type], ["position", int32_type], ["childrenValues", array_type(gen0)], ["value", gen0], ["parentValue", gen0], ["itemType", TreeItemType_$reflection()], ["getTreeItemProps", lambda_type(unit_type, HeadlessTreeItemProps$1_$reflection(gen0))]]);
}

export class HeadlessFlatTree$3 extends Record {
    constructor(getTreeProps, navigate, getNextNavigableItem, getElementFromItem, items) {
        super();
        this.getTreeProps = getTreeProps;
        this.navigate = navigate;
        this.getNextNavigableItem = getNextNavigableItem;
        this.getElementFromItem = getElementFromItem;
        this.items = items;
    }
}

export function HeadlessFlatTree$3_$reflection(gen0, gen1, gen2) {
    return record_type("FS.FluentUI.HeadlessFlatTree`3", [gen0, gen1, gen2], HeadlessFlatTree$3, () => [["getTreeProps", lambda_type(unit_type, FlatTreeProps$3_$reflection(gen0, gen1, gen2))], ["navigate", lambda_type(TreeNavigationData_unstable$2_$reflection(gen0, gen1), unit_type)], ["getNextNavigableItem", lambda_type(array_type(HeadlessTreeItem$1_$reflection(gen0)), lambda_type(TreeNavigationData_unstable$2_$reflection(gen0, gen1), option_type(HeadlessTreeItem$1_$reflection(gen0))))], ["getElementFromItem", lambda_type(HeadlessTreeItem$1_$reflection(gen0), class_type("Browser.Types.HTMLElement"))], ["items", lambda_type(unit_type, class_type("System.Collections.Generic.IEnumerable`1", [HeadlessTreeItem$1_$reflection(gen0)]))]]);
}

export class HeadlessFlatTree$2 extends Record {
    constructor(getTreeProps, navigate, getNextNavigableItem, getElementFromItem, items) {
        super();
        this.getTreeProps = getTreeProps;
        this.navigate = navigate;
        this.getNextNavigableItem = getNextNavigableItem;
        this.getElementFromItem = getElementFromItem;
        this.items = items;
    }
}

export function HeadlessFlatTree$2_$reflection(gen0, gen1) {
    return record_type("FS.FluentUI.HeadlessFlatTree`2", [gen0, gen1], HeadlessFlatTree$2, () => [["getTreeProps", lambda_type(unit_type, string_type)], ["navigate", lambda_type(TreeNavigationData_unstable$2_$reflection(gen0, gen1), unit_type)], ["getNextNavigableItem", lambda_type(array_type(HeadlessTreeItem$1_$reflection(gen0)), lambda_type(TreeNavigationData_unstable$2_$reflection(gen0, gen1), option_type(HeadlessTreeItem$1_$reflection(gen0))))], ["getElementFromItem", lambda_type(HeadlessTreeItem$1_$reflection(gen0), class_type("Browser.Types.HTMLElement"))], ["items", lambda_type(unit_type, class_type("System.Collections.Generic.IEnumerable`1", [HeadlessTreeItem$1_$reflection(gen0)]))]]);
}

export class TimePickerErrorType extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["invalid-input", "out-of-bounds", "required-input"];
    }
}

export function TimePickerErrorType_$reflection() {
    return union_type("FS.FluentUI.TimePickerErrorType", [], TimePickerErrorType, () => [[], [], []]);
}

export class TimeStringValidationResult extends Record {
    constructor(date, errorType) {
        super();
        this.date = date;
        this.errorType = errorType;
    }
}

export function TimeStringValidationResult_$reflection() {
    return record_type("FS.FluentUI.TimeStringValidationResult", [], TimeStringValidationResult, () => [["date", option_type(class_type("System.DateTime"))], ["errorType", TimePickerErrorType_$reflection()]]);
}

export class TimeSelectionData extends Record {
    constructor(selectedTime, selectedTimeText, errorType) {
        super();
        this.selectedTime = selectedTime;
        this.selectedTimeText = selectedTimeText;
        this.errorType = errorType;
    }
}

export function TimeSelectionData_$reflection() {
    return record_type("FS.FluentUI.TimeSelectionData", [], TimeSelectionData, () => [["selectedTime", option_type(class_type("System.DateTime"))], ["selectedTimeText", option_type(string_type)], ["errorType", option_type(TimePickerErrorType_$reflection())]]);
}

export function TimeSelectionDataModule_parse(data) {
    let matchValue;
    return new TimeSelectionData(data.selectedTime, data.selectedTimeText, (matchValue = data.errorType, (matchValue != null) ? ((matchValue === "invalid-input") ? (new TimePickerErrorType(0, [])) : ((matchValue === "out-of-bounds") ? (new TimePickerErrorType(1, [])) : ((matchValue === "required-input") ? (new TimePickerErrorType(2, [])) : undefined))) : undefined));
}

export class MotionType extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["entering", "entered", "idle", "exiting", "exited", "unmounted"];
    }
}

export function MotionType_$reflection() {
    return union_type("FS.FluentUI.MotionType", [], MotionType, () => [[], [], [], [], [], []]);
}

export class TeachingPopoverPageChangeData extends Record {
    constructor(currentPage) {
        super();
        this.currentPage = (currentPage | 0);
    }
}

export function TeachingPopoverPageChangeData_$reflection() {
    return record_type("FS.FluentUI.TeachingPopoverPageChangeData", [], TeachingPopoverPageChangeData, () => [["currentPage", int32_type]]);
}

export class AccordionToggleData$1 extends Record {
    constructor(value, openItems) {
        super();
        this.value = value;
        this.openItems = openItems;
    }
}

export function AccordionToggleData$1_$reflection(gen0) {
    return record_type("FS.FluentUI.AccordionToggleData`1", [gen0], AccordionToggleData$1, () => [["value", gen0], ["openItems", array_type(gen0)]]);
}

export class RatingOnChangeEventData$1 extends Record {
    constructor(value, type, event) {
        super();
        this.value = value;
        this.type = type;
        this.event = event;
    }
}

export function RatingOnChangeEventData$1_$reflection(gen0) {
    return record_type("FS.FluentUI.RatingOnChangeEventData`1", [gen0], RatingOnChangeEventData$1, () => [["value", gen0], ["type", string_type], ["event", class_type("Browser.Types.MouseEvent")]]);
}

export class OptionValue extends Record {
    constructor(disabled, id, text, value) {
        super();
        this.disabled = disabled;
        this.id = id;
        this.text = text;
        this.value = value;
    }
}

export function OptionValue_$reflection() {
    return record_type("FS.FluentUI.OptionValue", [], OptionValue, () => [["disabled", bool_type], ["id", string_type], ["text", string_type], ["value", string_type]]);
}

export class ActiveOptionChangeData extends Record {
    constructor(previousOption, nextOption) {
        super();
        this.previousOption = previousOption;
        this.nextOption = nextOption;
    }
}

export function ActiveOptionChangeData_$reflection() {
    return record_type("FS.FluentUI.ActiveOptionChangeData", [], ActiveOptionChangeData, () => [["previousOption", option_type(OptionValue_$reflection())], ["nextOption", option_type(OptionValue_$reflection())]]);
}

export class TagPickerOnOpenChangeData$1 extends Record {
    constructor(open, type, event) {
        super();
        this.open = open;
        this.type = type;
        this.event = event;
    }
}

export function TagPickerOnOpenChangeData$1_$reflection(gen0) {
    return record_type("FS.FluentUI.TagPickerOnOpenChangeData`1", [gen0], TagPickerOnOpenChangeData$1, () => [["open", bool_type], ["type", option_type(string_type)], ["event", gen0]]);
}

export class TagPickerOnOptionSelectData$1 extends Record {
    constructor(value, selectedOptions, type, event) {
        super();
        this.value = value;
        this.selectedOptions = selectedOptions;
        this.type = type;
        this.event = event;
    }
}

export function TagPickerOnOptionSelectData$1_$reflection(gen0) {
    return record_type("FS.FluentUI.TagPickerOnOptionSelectData`1", [gen0], TagPickerOnOptionSelectData$1, () => [["value", string_type], ["selectedOptions", array_type(string_type)], ["type", option_type(string_type)], ["event", gen0]]);
}

export class SwatchPickerOnSelectionChangeData extends Record {
    constructor(type, event, selectedValue, selectedSwatch) {
        super();
        this.type = type;
        this.event = event;
        this.selectedValue = selectedValue;
        this.selectedSwatch = selectedSwatch;
    }
}

export function SwatchPickerOnSelectionChangeData_$reflection() {
    return record_type("FS.FluentUI.SwatchPickerOnSelectionChangeData", [], SwatchPickerOnSelectionChangeData, () => [["type", string_type], ["event", class_type("Browser.Types.MouseEvent")], ["selectedValue", string_type], ["selectedSwatch", string_type]]);
}

export class RenderRowData$1 extends Record {
    constructor(children, rowId) {
        super();
        this.children = children;
        this.rowId = rowId;
    }
}

export function RenderRowData$1_$reflection(gen0) {
    return record_type("FS.FluentUI.RenderRowData`1", [gen0], RenderRowData$1, () => [["children", array_type(class_type("Fable.React.ReactElement", undefined))], ["rowId", gen0]]);
}

export class PresenceMotion extends Record {
    constructor(enter, exit) {
        super();
        this.enter = enter;
        this.exit = exit;
    }
}

export function PresenceMotion_$reflection() {
    return record_type("FS.FluentUI.PresenceMotion", [], PresenceMotion, () => [["enter", list_type(string_type)], ["exit", list_type(string_type)]]);
}

export class SetPlayState extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["running", "paused"];
    }
}

export function SetPlayState_$reflection() {
    return union_type("FS.FluentUI.SetPlayState", [], SetPlayState, () => [[], []]);
}

export class MotionImperativeRef extends Record {
    constructor(setPlaybackRate, setPlayState) {
        super();
        this.setPlaybackRate = setPlaybackRate;
        this.setPlayState = setPlayState;
    }
}

export function MotionImperativeRef_$reflection() {
    return record_type("FS.FluentUI.MotionImperativeRef", [], MotionImperativeRef, () => [["setPlaybackRate", lambda_type(int32_type, unit_type)], ["setPlayState", lambda_type(SetPlayState_$reflection(), unit_type)]]);
}

export class Direction extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["enter", "exit"];
    }
}

export function Direction_$reflection() {
    return union_type("FS.FluentUI.Direction", [], Direction, () => [[], []]);
}

export class OnMotionData extends Record {
    constructor(direction) {
        super();
        this.direction = direction;
    }
}

export function OnMotionData_$reflection() {
    return record_type("FS.FluentUI.OnMotionData", [], OnMotionData, () => [["direction", Direction_$reflection()]]);
}

export class MotionTokens extends Record {
    constructor(curveAccelerateMax, curveAccelerateMid, curveAccelerateMin, curveDecelerateMax, curveDecelerateMid, curveDecelerateMin, curveEasyEaseMax, curveEasyEase, curveLinear, durationUltraFast, durationFaster, durationFast, durationNormal, durationGentle, durationSlow, durationSlower, durationUltraSlow) {
        super();
        this.curveAccelerateMax = curveAccelerateMax;
        this.curveAccelerateMid = curveAccelerateMid;
        this.curveAccelerateMin = curveAccelerateMin;
        this.curveDecelerateMax = curveDecelerateMax;
        this.curveDecelerateMid = curveDecelerateMid;
        this.curveDecelerateMin = curveDecelerateMin;
        this.curveEasyEaseMax = curveEasyEaseMax;
        this.curveEasyEase = curveEasyEase;
        this.curveLinear = curveLinear;
        this.durationUltraFast = (durationUltraFast | 0);
        this.durationFaster = (durationFaster | 0);
        this.durationFast = (durationFast | 0);
        this.durationNormal = (durationNormal | 0);
        this.durationGentle = (durationGentle | 0);
        this.durationSlow = (durationSlow | 0);
        this.durationSlower = (durationSlower | 0);
        this.durationUltraSlow = (durationUltraSlow | 0);
    }
}

export function MotionTokens_$reflection() {
    return record_type("FS.FluentUI.MotionTokens", [], MotionTokens, () => [["curveAccelerateMax", string_type], ["curveAccelerateMid", string_type], ["curveAccelerateMin", string_type], ["curveDecelerateMax", string_type], ["curveDecelerateMid", string_type], ["curveDecelerateMin", string_type], ["curveEasyEaseMax", string_type], ["curveEasyEase", string_type], ["curveLinear", string_type], ["durationUltraFast", int32_type], ["durationFaster", int32_type], ["durationFast", int32_type], ["durationNormal", int32_type], ["durationGentle", int32_type], ["durationSlow", int32_type], ["durationSlower", int32_type], ["durationUltraSlow", int32_type]]);
}

export class CarouselIndexChangeData extends Record {
    constructor(index, type, event) {
        super();
        this.index = (index | 0);
        this.type = type;
        this.event = event;
    }
}

export function CarouselIndexChangeData_$reflection() {
    return record_type("FS.FluentUI.CarouselIndexChangeData", [], CarouselIndexChangeData, () => [["index", int32_type], ["type", option_type(string_type)], ["event", class_type("Browser.Types.MouseEvent")]]);
}

export class CarouselAutoplayChangeData extends Record {
    constructor(checked, type, event) {
        super();
        this.checked = checked;
        this.type = type;
        this.event = event;
    }
}

export function CarouselAutoplayChangeData_$reflection() {
    return record_type("FS.FluentUI.CarouselAutoplayChangeData", [], CarouselAutoplayChangeData, () => [["checked", bool_type], ["type", option_type(string_type)], ["event", class_type("Browser.Types.MouseEvent")]]);
}

export class OverflowState$2 extends Record {
    constructor(hasOverflow, itemVisibility, groupVisibility) {
        super();
        this.hasOverflow = hasOverflow;
        this.itemVisibility = itemVisibility;
        this.groupVisibility = groupVisibility;
    }
}

export function OverflowState$2_$reflection(gen0, gen1) {
    return record_type("FS.FluentUI.OverflowState`2", [gen0, gen1], OverflowState$2, () => [["hasOverflow", bool_type], ["itemVisibility", gen0], ["groupVisibility", gen1]]);
}

export class OnNavItemSelectData extends Record {
    constructor(type, event, value, categoryValue) {
        super();
        this.type = type;
        this.event = event;
        this.value = value;
        this.categoryValue = categoryValue;
    }
}

export function OnNavItemSelectData_$reflection() {
    return record_type("FS.FluentUI.OnNavItemSelectData", [], OnNavItemSelectData, () => [["type", option_type(string_type)], ["event", class_type("Browser.Types.MouseEvent")], ["value", string_type], ["categoryValue", string_type]]);
}

export class OnListSelectionChangeData$2 extends Record {
    constructor(selectedItems, type, event) {
        super();
        this.selectedItems = selectedItems;
        this.type = type;
        this.event = event;
    }
}

export function OnListSelectionChangeData$2_$reflection(gen0, gen1) {
    return record_type("FS.FluentUI.OnListSelectionChangeData`2", [gen0, gen1], OnListSelectionChangeData$2, () => [["selectedItems", array_type(gen0)], ["type", string_type], ["event", gen1]]);
}

export class ListItemActionEventData$2 extends Record {
    constructor(value, type, event) {
        super();
        this.value = value;
        this.type = type;
        this.event = event;
    }
}

export function ListItemActionEventData$2_$reflection(gen0, gen1) {
    return record_type("FS.FluentUI.ListItemActionEventData`2", [gen0, gen1], ListItemActionEventData$2, () => [["value", gen0], ["type", string_type], ["event", gen1]]);
}

export class FixedSizeListRenderProps$1 extends Record {
    constructor(data, index, isScrolling, style) {
        super();
        this.data = data;
        this.index = (index | 0);
        this.isScrolling = isScrolling;
        this.style = style;
    }
}

export function FixedSizeListRenderProps$1_$reflection(gen0) {
    return record_type("FS.FluentUI.FixedSizeListRenderProps`1", [gen0], FixedSizeListRenderProps$1, () => [["data", array_type(gen0)], ["index", int32_type], ["isScrolling", option_type(bool_type)], ["style", obj_type]]);
}

export class OnFixedSizeListItemsRendered extends Record {
    constructor(overscanStartIndex, overscanStopIndex, visibleStartIndex, visibleStopIndex) {
        super();
        this.overscanStartIndex = (overscanStartIndex | 0);
        this.overscanStopIndex = (overscanStopIndex | 0);
        this.visibleStartIndex = (visibleStartIndex | 0);
        this.visibleStopIndex = (visibleStopIndex | 0);
    }
}

export function OnFixedSizeListItemsRendered_$reflection() {
    return record_type("FS.FluentUI.OnFixedSizeListItemsRendered", [], OnFixedSizeListItemsRendered, () => [["overscanStartIndex", int32_type], ["overscanStopIndex", int32_type], ["visibleStartIndex", int32_type], ["visibleStopIndex", int32_type]]);
}

export class OnFixedSizeListScroll extends Record {
    constructor(scrollDirection, scrollOffset, scrollUpdateWasRequested) {
        super();
        this.scrollDirection = scrollDirection;
        this.scrollOffset = (scrollOffset | 0);
        this.scrollUpdateWasRequested = scrollUpdateWasRequested;
    }
}

export function OnFixedSizeListScroll_$reflection() {
    return record_type("FS.FluentUI.OnFixedSizeListScroll", [], OnFixedSizeListScroll, () => [["scrollDirection", string_type], ["scrollOffset", int32_type], ["scrollUpdateWasRequested", bool_type]]);
}

export class RGB extends Record {
    constructor(r, g, b) {
        super();
        this.r = r;
        this.g = g;
        this.b = b;
    }
}

export function RGB_$reflection() {
    return record_type("FS.FluentUI.RGB", [], RGB, () => [["r", string_type], ["g", string_type], ["b", string_type]]);
}

export class RGBA extends Record {
    constructor(r, g, b, a) {
        super();
        this.r = r;
        this.g = g;
        this.b = b;
        this.a = a;
    }
}

export function RGBA_$reflection() {
    return record_type("FS.FluentUI.RGBA", [], RGBA, () => [["r", string_type], ["g", string_type], ["b", string_type], ["a", string_type]]);
}

export class HSL extends Record {
    constructor(h, s, l) {
        super();
        this.h = h;
        this.s = s;
        this.l = l;
    }
}

export function HSL_$reflection() {
    return record_type("FS.FluentUI.HSL", [], HSL, () => [["h", string_type], ["s", string_type], ["l", string_type]]);
}

export class HSLA extends Record {
    constructor(h, s, l, a) {
        super();
        this.h = h;
        this.s = s;
        this.l = l;
        this.a = a;
    }
}

export function HSLA_$reflection() {
    return record_type("FS.FluentUI.HSLA", [], HSLA, () => [["h", string_type], ["s", string_type], ["l", string_type], ["a", string_type]]);
}

export class HSV extends Record {
    constructor(h, s, v) {
        super();
        this.h = h;
        this.s = s;
        this.v = v;
    }
}

export function HSV_$reflection() {
    return record_type("FS.FluentUI.HSV", [], HSV, () => [["h", string_type], ["s", string_type], ["v", string_type]]);
}

export class HSVA extends Record {
    constructor(h, s, v, a) {
        super();
        this.h = h;
        this.s = s;
        this.v = v;
        this.a = a;
    }
}

export function HSVA_$reflection() {
    return record_type("FS.FluentUI.HSVA", [], HSVA, () => [["h", float64_type], ["s", float64_type], ["v", float64_type], ["a", float64_type]]);
}

export class ColorPickerOnChangeData extends Record {
    constructor(type, event, color) {
        super();
        this.type = type;
        this.event = event;
        this.color = color;
    }
}

export function ColorPickerOnChangeData_$reflection() {
    return record_type("FS.FluentUI.ColorPickerOnChangeData", [], ColorPickerOnChangeData, () => [["type", string_type], ["event", class_type("Browser.Types.MouseEvent")], ["color", HSVA_$reflection()]]);
}

export class TinyColorOptions extends Record {
    constructor(format, gradientType) {
        super();
        this.format = format;
        this.gradientType = gradientType;
    }
}

export function TinyColorOptions_$reflection() {
    return record_type("FS.FluentUI.TinyColorOptions", [], TinyColorOptions, () => [["format", string_type], ["gradientType", string_type]]);
}

export class ColorFormats extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["rgb", "prgb", "hex", "hex3", "hex4", "hex6", "hex8", "name", "hsl", "hsv"];
    }
}

export function ColorFormats_$reflection() {
    return union_type("FS.FluentUI.ColorFormats", [], ColorFormats, () => [[], [], [], [], [], [], [], [], [], []]);
}

export class ColorInput extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["String", "Int", "RGB", "RGBA", "HSL", "HSLA", "HSV", "HSVA", "TinyColor"];
    }
}

export function ColorInput_$reflection() {
    return union_type("FS.FluentUI.ColorInput", [], ColorInput, () => [[["Item", string_type]], [["Item", int32_type]], [["Item", RGB_$reflection()]], [["Item", RGBA_$reflection()]], [["Item", HSL_$reflection()]], [["Item", HSLA_$reflection()]], [["Item", HSV_$reflection()]], [["Item", HSVA_$reflection()]], [["Item", TinyColor_$reflection()]]]);
}

export class TinyColor extends Record {
    constructor(r, g, b, a, format, originalInput, isValid, gradientType, roundA, constructor, isDark, isLight, getBrightness, getLuminance, getAlpha, setAlpha, toHsv, toHsvString, toHsl, toHslString, toHex, toHexString, toHex8, toHex8String, toRgb, toRgbString, toPercentageRgb, toPercentageRgbString, toName, toString, toNumber, clone, lighten, brighten, darken, tint, shade, desaturate, saturate, greyscale, spin, mix, analogous, complement, monochromatic, splitcomplement, onBackground, triad, tetrad, polyad, equals) {
        super();
        this.r = (r | 0);
        this.g = (g | 0);
        this.b = (b | 0);
        this.a = (a | 0);
        this.format = format;
        this.originalInput = originalInput;
        this.isValid = isValid;
        this.gradientType = gradientType;
        this.roundA = (roundA | 0);
        this.constructor$ = constructor;
        this.isDark = isDark;
        this.isLight = isLight;
        this.getBrightness = getBrightness;
        this.getLuminance = getLuminance;
        this.getAlpha = getAlpha;
        this.setAlpha = setAlpha;
        this.toHsv = toHsv;
        this.toHsvString = toHsvString;
        this.toHsl = toHsl;
        this.toHslString = toHslString;
        this.toHex = toHex;
        this.toHexString = toHexString;
        this.toHex8 = toHex8;
        this.toHex8String = toHex8String;
        this.toRgb = toRgb;
        this.toRgbString = toRgbString;
        this.toPercentageRgb = toPercentageRgb;
        this.toPercentageRgbString = toPercentageRgbString;
        this.toName = toName;
        this.toString = toString;
        this.toNumber = toNumber;
        this.clone = clone;
        this.lighten = lighten;
        this.brighten = brighten;
        this.darken = darken;
        this.tint = tint;
        this.shade = shade;
        this.desaturate = desaturate;
        this.saturate = saturate;
        this.greyscale = greyscale;
        this.spin = spin;
        this.mix = mix;
        this.analogous = analogous;
        this.complement = complement;
        this.monochromatic = monochromatic;
        this.splitcomplement = splitcomplement;
        this.onBackground = onBackground;
        this.triad = triad;
        this.tetrad = tetrad;
        this.polyad = polyad;
        this.equals = equals;
    }
}

export function TinyColor_$reflection() {
    return record_type("FS.FluentUI.TinyColor", [], TinyColor, () => [["r", int32_type], ["g", int32_type], ["b", int32_type], ["a", int32_type], ["format", ColorFormats_$reflection()], ["originalInput", ColorInput_$reflection()], ["isValid", bool_type], ["gradientType", string_type], ["roundA", int32_type], ["constructor$", lambda_type(ColorInput_$reflection(), lambda_type(TinyColorOptions_$reflection(), unit_type))], ["isDark", lambda_type(unit_type, bool_type)], ["isLight", lambda_type(unit_type, bool_type)], ["getBrightness", lambda_type(unit_type, int32_type)], ["getLuminance", lambda_type(unit_type, int32_type)], ["getAlpha", lambda_type(unit_type, int32_type)], ["setAlpha", lambda_type(string_type, unit_type)], ["toHsv", lambda_type(unit_type, HSV_$reflection())], ["toHsvString", lambda_type(unit_type, string_type)], ["toHsl", lambda_type(unit_type, HSLA_$reflection())], ["toHslString", lambda_type(unit_type, string_type)], ["toHex", lambda_type(bool_type, string_type)], ["toHexString", lambda_type(bool_type, string_type)], ["toHex8", lambda_type(bool_type, string_type)], ["toHex8String", lambda_type(bool_type, string_type)], ["toRgb", lambda_type(unit_type, RGBA_$reflection())], ["toRgbString", lambda_type(unit_type, string_type)], ["toPercentageRgb", lambda_type(unit_type, RGBA_$reflection())], ["toPercentageRgbString", lambda_type(unit_type, string_type)], ["toName", lambda_type(unit_type, string_type)], ["toString", lambda_type(ColorFormats_$reflection(), string_type)], ["toNumber", lambda_type(unit_type, int32_type)], ["clone", lambda_type(unit_type, TinyColor_$reflection())], ["lighten", lambda_type(int32_type, TinyColor_$reflection())], ["brighten", lambda_type(int32_type, TinyColor_$reflection())], ["darken", lambda_type(int32_type, TinyColor_$reflection())], ["tint", lambda_type(int32_type, TinyColor_$reflection())], ["shade", lambda_type(int32_type, TinyColor_$reflection())], ["desaturate", lambda_type(int32_type, TinyColor_$reflection())], ["saturate", lambda_type(int32_type, TinyColor_$reflection())], ["greyscale", lambda_type(unit_type, TinyColor_$reflection())], ["spin", lambda_type(int32_type, TinyColor_$reflection())], ["mix", lambda_type(ColorInput_$reflection(), lambda_type(int32_type, TinyColor_$reflection()))], ["analogous", lambda_type(int32_type, lambda_type(int32_type, array_type(TinyColor_$reflection())))], ["complement", lambda_type(unit_type, TinyColor_$reflection())], ["monochromatic", lambda_type(int32_type, array_type(TinyColor_$reflection()))], ["splitcomplement", lambda_type(unit_type, array_type(TinyColor_$reflection()))], ["onBackground", lambda_type(ColorInput_$reflection(), TinyColor_$reflection())], ["triad", lambda_type(unit_type, array_type(TinyColor_$reflection()))], ["tetrad", lambda_type(unit_type, array_type(TinyColor_$reflection()))], ["polyad", lambda_type(int32_type, array_type(TinyColor_$reflection()))], ["equals", lambda_type(ColorInput_$reflection(), bool_type)]]);
}

export class TagSelectData extends Record {
    constructor(value, selectedValues) {
        super();
        this.value = value;
        this.selectedValues = selectedValues;
    }
}

export function TagSelectData_$reflection() {
    return record_type("FS.FluentUI.TagSelectData", [], TagSelectData, () => [["value", string_type], ["selectedValues", array_type(string_type)]]);
}

//# sourceMappingURL=Domain.fs.js.map
